import {getSpinner, isMatchMedia} from '%helpers%/utils';
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');

import {
  showWidgetError,
  hideWidgetError,
  hideLoading,
  showLoading,
  validateField,
  initTomSelect,
  initTomMultiCheckboxSelect,
  initInputMaskByKey,
  initIntlTelInput,
  initRangeSlider,
  initInputMask,
  watchPropertyAgainstMortgage,
  getQueryParam,
  getHubSpotUtk,
  setQueryParam,
  removeQueryParam,
} from '%helpers%/helpers';
import {debounce} from 'lodash';
import wNumb from 'wnumb';

const reportErrorToServer = (context, error, statusCode = null) => {
  try {
    fetch('//' + window.PREQUAL_EMBED.api + '/form-proxy/log-error', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Embed-PublicKey': window.PREQUAL_EMBED.publicKey,
      },
      body: JSON.stringify({
        context,
        message: error?.message || String(error),
        stack: error?.stack || null,
        url: window.location.href,
        embedId: window.PREQUAL_EMBED.embedId,
        statusCode,
      }),
    }).catch(() => {});
  } catch (_) {}
};

(async function () {
  const embed = document.querySelector('[data-prequal-form-embed]');

  if (!embed) return;

  const theme = window.PREQUAL_EMBED?.theme;
  const isLatham = theme === 'Latham';
  const mapKey = window.PREQUAL_EMBED?.mapKey;
  const defaultCssLink = document.createElement('link');
  defaultCssLink.rel = 'stylesheet';
  defaultCssLink.href = '//' + window.PREQUAL_EMBED.api + '/css/seq-partner-Default.css';
  document.head.appendChild(defaultCssLink);
  if (theme && theme != '' && theme != 'Default') {
    const themedCssLink = document.createElement('link');
    themedCssLink.rel = 'stylesheet';
    themedCssLink.href = '//' + window.PREQUAL_EMBED.api + '/css/seq-partner-' + theme + '.css';
    document.head.appendChild(themedCssLink);
  }
  if (
    !window._gmapsLoading &&
    !(window.google && window.google?.maps) &&
    !document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]') &&
    mapKey
  ) {
    const script = document.createElement('script');
    script.src =
      'https://maps.googleapis.com/maps/api/js?key=' + mapKey + '&libraries=places&v=weekly&loading=async';
    script.defer = true;

    document.head.appendChild(script);
  }
  if (!document.querySelector('script[src*="GTM-PT63XZRL"]')) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
    const gtmScript = document.createElement('script');
    gtmScript.async = true;
    gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-PT63XZRL';
    document.head.appendChild(gtmScript);
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) window.location.reload();
  });

  const url =
    '//' + window.PREQUAL_EMBED.api + '/form-proxy/getsnippet?embedId=' + window.PREQUAL_EMBED.embedId;
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'X-Embed-PublicKey': window.PREQUAL_EMBED.publicKey,
      },
    });

    if (!response.ok) throw new Error(`API error: ${response.status}`);

    const html = await response.text();

    embed.innerHTML += html;

    embed.querySelectorAll('.widget-form_rate').forEach(widget => {
      showLoading(widget);
      initiateEmbedFormRate(widget);
      hideLoading(widget);
    });
  } catch (error) {
    console.error('Error fetching loan options:', error);
  }
})();
const initiateEmbedFormRate = widget => {
  if (!widget) return;

  const form = widget.querySelector('form');
  if (!form) return;
  const isLatham = window.PREQUAL_EMBED?.theme === 'Latham';
  const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const isStepsMode = widget.classList.contains('with-steps');
  let lead = null;
  let activeStep = 1;
  let resultsLoaded = false;
  let prefillComplete = false;
  let suppressSetEvent = false;
  const submitBtn = form.querySelector(".btn[type='submit']");
  const noResults = widget.querySelector('.products-no-results');
  const withResults = widget.querySelector('.has-results');
  const positiveMessage = widget.querySelector('.positivie-message');
  const cards = form.querySelectorAll(`[data-scenario]`);
  let sliderEl = widget.querySelector('.js-range-slider');
  let sessionStorageRecordId = sessionStorage.getItem('UmbracoFormsRecordId');
  const formatter = wNumb({
    decimals: 0,
    thousand: ',',
    prefix: '$',
  });

  const formFieldSelectors =
    'input.form-control, input.input-control, textarea.form-control, select.select-control, .radio-group input[type="radio"]';

  const validateWrapper = (wrapper, markInvalid = false) => {
    const fields = wrapper.querySelectorAll(
      'input.form-control, input.input-control, textarea.form-control, select.select-control, .radio-group input[type="radio"]'
    );

    let allValid = true;

    fields.forEach(input => {
      const valid = validateField(input, markInvalid);
      if (!valid) allValid = false;
    });

    const selects = wrapper.querySelectorAll('select.select-control');
    selects.forEach(input => {
      const value = input.value;
      const valid = value !== null && value !== undefined && value.toString().trim() !== '';
      if (!valid) allValid = false;
    });

    return allValid;
  };

  const validateForm = (markInvalid = false) => {
    const valid = validateWrapper(form, markInvalid);
    if (submitBtn) submitBtn.disabled = !valid;
    return valid;
  };

  const validateStep = (step, markInvalid = false) => {
    if (!step) return;
    step = Number(step);
    if (Number.isNaN(step)) return false;
    const stepWrapper = widget.querySelector(`.tab-pane[data-step="${step}"]`);
    if (!stepWrapper) return;

    const fieldsValid = validateWrapper(stepWrapper, markInvalid);
    const equityBlocked = stepWrapper.dataset.insufficientEquity === 'true';
    const valid = fieldsValid && !equityBlocked;
    const nextBtn = stepWrapper.querySelector(`[data-action="changeStep"][data-step="${step + 1}"]`);
    const nextTab = widget.querySelector(`[data-bs-toggle="tab"][data-step="${step + 1}"]`);

    if (nextBtn) nextBtn.disabled = !valid;
    if (nextTab) nextTab.disabled = !valid;

    return valid;
  };

  const attachValidationHandlers = (wrapper, step = null) => {
    const handler = debounce(() => {
      if (isStepsMode && step) {
        validateStep(step);
      } else {
        validateForm();
      }
    }, 250);

    wrapper.addEventListener('input', e => {
      if (!e.target.matches(formFieldSelectors)) return;
      e.target.dataset.touched = 'true';
      handler();
    });

    wrapper.addEventListener('change', e => {
      if (!e.target.matches(formFieldSelectors)) return;
      e.target.dataset.touched = 'true';
      handler();
    });

    wrapper.addEventListener(
      'blur',
      e => {
        if (!e.target.matches(formFieldSelectors)) return;
        e.target.dataset.touched = 'true';
        handler();
      },
      true
    );
  };

  const submitForm = async e => {
    e.preventDefault();

    if (!validateForm()) return;
    AddSkeleton();
    try {
      // const formData = new FormData(form);
      const data = await submitEntryToUmbracoFormsAndFetchData();
      if (data?.invalidState) {
        ShowMessageModal(data?.message);
        return;
      }
      initLoanAmountSlider(data);
      updateContactCard(data);
      updateLoanCards(JSON.parse(data.result));
      // setFormDataSessionStorage(formData);
    } catch (error) {
      console.error('Form submit error:', error);
    } finally {
      RemoveSkeleton();
    }
  };
  form.addEventListener('submit', submitForm);

  const changeStep = async step => {
    const widgetFormContent = form.closest('.widget-form-content');
    window.UmbracoForms.reinitConditions(widgetFormContent);
    let result;
    if (activeStep === step) return;
    if (activeStep == 1) {
      let queryLeadId = getQueryParam('hs_object_id');
      if (queryLeadId) {
        result = await updateLead();
      } else {
        lead = await createOrUpdateLeadByEmail();
        result = lead;
        if (lead?.leadEventId) setQueryParam('hs_object_id', lead.leadEventId);
      }
    }
    if (result?.invalidState) {
      ShowMessageModal(result?.message);
      return;
    }
    activeStep = step;
    const tab = widget.querySelector(`[data-bs-toggle="tab"][data-step="${step}"]`);
    if (tab) bootstrap.Tab.getOrCreateInstance(tab).show();
    const gtmStepNames = {1: 'Lead Info', 2: 'Property Info', 3: 'Loan Results'};
    const gtmStepName = gtmStepNames[step];
    if (gtmStepName) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event: 'page_view', page_title: gtmStepName, step_name: gtmStepName});
    }
  };

  async function prefillForm() {
    let queryLeadId = getQueryParam('hs_object_id');
    // const savedData = sessionStorage.getItem('formData');
    if (!queryLeadId) return;

    if (queryLeadId) {
      try {
        showLoading(form);
        const url = '//' + window.PREQUAL_EMBED.api + '/form-proxy/hubspot/get/' + queryLeadId;
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Embed-PublicKey': window.PREQUAL_EMBED.publicKey,
          },
        });
        lead = await response.json();
        const hubspotLeadMapping =
          form.querySelector('[data-mapping-lead]')?.getAttribute('data-mapping-lead') || null;

        if (lead && hubspotLeadMapping) {
          const dataObj = JSON.parse(hubspotLeadMapping);
          dataObj.forEach(item => {
            if (!guidRegex.test(item.value)) return;

            const inputs = form.querySelectorAll(`[name="${item.value}"]`);
            const value = lead[item.alias];
            if (!inputs || !value) return;

            inputs.forEach(el => {
              const type = el.type;

              if (type === 'checkbox') {
                if (Array.isArray(value)) {
                  el.checked = value.includes(el.value);
                } else {
                  el.checked = el.value === value;
                }
              } else if (type === 'radio') {
                el.checked = el.value === value;

                if (el.checked) {
                  el.dispatchEvent(new Event('change', {bubbles: true}));
                }
              } else if (el.tagName.toLowerCase() === 'select') {
                if (el.multiple) {
                  const values = Array.isArray(value) ? value : [value];

                  Array.from(el.options).forEach(option => {
                    option.selected = values.includes(option.value);
                  });
                } else {
                  el.value = Array.isArray(value) ? value[0] : value;
                }

                el.dispatchEvent(new Event('change', {bubbles: true}));

                return;
              } else {
                el.value = value;
                el.dispatchEvent(new Event('blur', {bubbles: true}));
              }
              if (item.alias == 'email') {
                el.readOnly = true;
                const fieldWrapper = el.closest('.umbraco-forms-field');
                if (fieldWrapper) {
                  const label = fieldWrapper.querySelector('.umbraco-forms-label');
                  const span = document.createElement('span');
                  span.className = 'span-tooltip ms-1';
                  span.setAttribute('data-bs-toggle', 'tooltip');
                  span.setAttribute(
                    'data-bs-title',
                    'Your email address is locked because you already have an active record with us. All other information can be updated.'
                  );
                  span.textContent = '?';
                  label.appendChild(span);
                  bootstrap.Tooltip.getOrCreateInstance(span, {
                    placement: 'top',
                    trigger: 'hover',
                  });
                }
              }
            });
          });
        } else {
          removeQueryParam('hs_object_id');
        }
      } catch (error) {
        removeQueryParam('hs_object_id');
      } finally {
        hideLoading();
      }
    }
    // else {
    //   const dataObj = JSON.parse(savedData);

    //   Object.entries(dataObj).forEach(([key, value]) => {
    //     if (!guidRegex.test(key)) return;

    //     const inputs = form.querySelectorAll(`[name="${key}"]`);
    //     if (!inputs || !value) return;

    //     inputs.forEach(el => {
    //       const type = el.type;

    //       if (type === 'checkbox') {
    //         if (Array.isArray(value)) {
    //           el.checked = value.includes(el.value);
    //         } else {
    //           el.checked = el.value === value;
    //         }
    //       } else if (type === 'radio') {
    //         el.checked = el.value === value;

    //         if (el.checked) {
    //           el.dispatchEvent(new Event('change', {bubbles: true}));
    //         }
    //       } else if (el.tagName.toLowerCase() === 'select') {
    //         const ts = el.tomselect;

    //         if (Array.isArray(value)) {
    //           ts.setValue(value, true); // silent
    //         } else {
    //           ts.setValue(value, true);
    //         }
    //         return;
    //       } else {
    //         el.value = value;
    //       }
    //     });
    //   });
    // }
    validateStep(activeStep);
  }

  function initLoanAmountSlider(data) {
    positiveMessage.classList.add('d-none');
    if (!data.request) return;

    let loanAmount = data.request.loanAmount;
    let propertyValue = data.request.propertyValue;
    let firstMortagage = data.request.firstMortgageBalance;
    let maxAmount = propertyValue * 0.9 - firstMortagage || 0;
    if (maxAmount > 500000) maxAmount = 500000;
    if (loanAmount && maxAmount) {
      if (sliderEl) {
        const wrapper = sliderEl.closest('.range-wrapper');
        if (!wrapper) return;
        const input = wrapper.querySelector('.range-control');
        const inputFormat = wrapper.querySelector('.range-format');
        const rangeMax = widget.querySelectorAll('.range-max');
        rangeMax.forEach(label => (label.textContent = formatter.to(maxAmount)));
        positiveMessage.classList.remove('d-none');
        if (inputFormat) inputFormat.value = loanAmount;
        if (input) {
          input.value = loanAmount;
          input.max = maxAmount;
        }
        suppressSetEvent = true;
        if (!sliderEl.noUiSlider) {
        } else {
          sliderEl.noUiSlider.updateOptions({
            range: {
              min: 25000,
              max: maxAmount,
            },
          });
        }
        sliderEl.noUiSlider.set(loanAmount);
        suppressSetEvent = false;
      }
    }
  }

  function setFormDataSessionStorage(formData) {
    const dataObj = {};

    formData.forEach((value, key) => {
      if (!value) return;
      if (!guidRegex.test(key)) return;

      const input = form.querySelector(`[name="${key}"]`);
      if (input?.type === 'checkbox') {
        if (!dataObj[key]) dataObj[key] = [];
        dataObj[key].push(value);
      } else {
        dataObj[key] = value;
      }
    });

    sessionStorage.setItem('formData', JSON.stringify(dataObj));
  }

  const createOrUpdateLeadByEmail = async () => {
    hideWidgetError();
    const formData = new FormData(form);
    const data = {
      EmbedId: window.PREQUAL_EMBED.embedId,
      Values: Object.fromEntries(formData.entries()),
    };

    const queryExternalID = getQueryParam('external_partner_id');
    const queryPandaKey = getQueryParam('cain_key') || getQueryParam('key');
    const queryBusinnessID = getQueryParam('business_line_distribution_id');
    const queryUtm_source = getQueryParam('Utm_source') || getQueryParam('utm_source');
    const queryUtm_medium = getQueryParam('Utm_medium') || getQueryParam('utm_medium');
    const queryUtm_campaign = getQueryParam('Utm_campaign') || getQueryParam('utm_campaign');
    const queryUtm_content = getQueryParam('Utm_content') || getQueryParam('utm_content');
    const queryUtm_term = getQueryParam('Utm_term') || getQueryParam('utm_term');

    if (queryExternalID) data.ExternalID = queryExternalID;
    if (queryPandaKey) data.PandaKey = queryPandaKey;
    if (queryBusinnessID) data.BusinessLineDistributionID = queryBusinnessID;
    if (queryUtm_source) data.Utm_source = queryUtm_source;
    if (queryUtm_medium) data.Utm_medium = queryUtm_medium;
    if (queryUtm_campaign) data.Utm_campaign = queryUtm_campaign;
    if (queryUtm_content) data.Utm_content = queryUtm_content;
    if (queryUtm_term) data.Utm_term = queryUtm_term;
    const hutk = getHubSpotUtk();
    if (hutk) data.Hutk = hutk;

    const url = '//' + window.PREQUAL_EMBED.api + '/form-proxy/hubspot/createOrUpdateByEmail/';

    try {
      showLoading(form);
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Embed-PublicKey': window.PREQUAL_EMBED.publicKey,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) throw new Error(`API error: ${response.status}`);

      const result = await response.json();
      return result;
    } catch (error) {
      showWidgetError(
        widget.querySelector('.tab-content'),
        'An error occurred while processing data. Please try again later.'
      );
      reportErrorToServer('createOrUpdateLeadByEmail', error);
      console.error('Error fetching loan options:', error);
      return null;
    } finally {
      hideLoading();
    }
  };

  const updateLead = async (product = null) => {
    hideWidgetError();
    let queryLeadId = getQueryParam('hs_object_id');
    const queryExternalID = getQueryParam('external_partner_id');
    const queryPandaKey = getQueryParam('cain_key') || getQueryParam('key');
    const queryBusinnessID = getQueryParam('business_line_distribution_id');
    const queryUtm_source = getQueryParam('Utm_source') || getQueryParam('utm_source');
    const queryUtm_medium = getQueryParam('Utm_medium') || getQueryParam('utm_medium');
    const queryUtm_campaign = getQueryParam('Utm_campaign') || getQueryParam('utm_campaign');
    const queryUtm_content = getQueryParam('Utm_content') || getQueryParam('utm_content');
    const queryUtm_term = getQueryParam('Utm_term') || getQueryParam('utm_term');

    const formData = new FormData(form);
    const data = {
      EmbedId: window.PREQUAL_EMBED.embedId,
      Values: Object.fromEntries(formData.entries()),
      ObjectId: queryLeadId,
    };

    if (queryExternalID) data.ExternalID = queryExternalID;
    if (queryPandaKey) data.PandaKey = queryPandaKey;
    if (queryBusinnessID) data.BusinessLineDistributionID = queryBusinnessID;
    if (queryUtm_source) data.Utm_source = queryUtm_source;
    if (queryUtm_medium) data.Utm_medium = queryUtm_medium;
    if (queryUtm_campaign) data.Utm_campaign = queryUtm_campaign;
    if (queryUtm_content) data.Utm_content = queryUtm_content;
    if (queryUtm_term) data.Utm_term = queryUtm_term;
    const hutk = getHubSpotUtk();
    if (hutk) data.Hutk = hutk;
    if (product) data.PrequalProductSelected = product;
    const url = '//' + window.PREQUAL_EMBED.api + '/form-proxy/hubspot/update/';

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Embed-PublicKey': window.PREQUAL_EMBED.publicKey,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) throw new Error(`API error: ${response.status}`);

      const result = await response.json();
      return result;
    } catch (error) {
      showWidgetError(
        widget.querySelector('.tab-content'),
        'An error occurred while processing data. Please try again later.'
      );
      reportErrorToServer('updateLead', error);
      console.error('Error fetching loan options:', error);
      return null;
    } finally {
    }
  };

  const submitEntryToUmbracoFormsAndFetchData = async () => {
    hideWidgetError();
    let queryLeadId = getQueryParam('hs_object_id');
    const formData = new FormData(form);
    formData.set('loanAmount', '0');
    const data = {
      EmbedId: window.PREQUAL_EMBED.embedId,
      Values: Object.fromEntries(formData.entries()),
      ObjectId: queryLeadId,
    };

    const queryExternalID = getQueryParam('external_partner_id');
    const queryPandaKey = getQueryParam('cain_key') || getQueryParam('key');
    const queryBusinnessID = getQueryParam('business_line_distribution_id');
    const queryUtm_source = getQueryParam('Utm_source') || getQueryParam('utm_source');
    const queryUtm_medium = getQueryParam('Utm_medium') || getQueryParam('utm_medium');
    const queryUtm_campaign = getQueryParam('Utm_campaign') || getQueryParam('utm_campaign');
    const queryUtm_content = getQueryParam('Utm_content') || getQueryParam('utm_content');
    const queryUtm_term = getQueryParam('Utm_term') || getQueryParam('utm_term');

    if (queryExternalID) data.ExternalID = queryExternalID;
    if (queryPandaKey) data.PandaKey = queryPandaKey;
    if (queryBusinnessID) data.BusinessLineDistributionID = queryBusinnessID;
    if (queryUtm_source) data.Utm_source = queryUtm_source;
    if (queryUtm_medium) data.Utm_medium = queryUtm_medium;
    if (queryUtm_campaign) data.Utm_campaign = queryUtm_campaign;
    if (queryUtm_content) data.Utm_content = queryUtm_content;
    if (queryUtm_term) data.Utm_term = queryUtm_term;
    const hutk = getHubSpotUtk();
    if (hutk) data.Hutk = hutk;

    const url = '//' + window.PREQUAL_EMBED.api + '/form-proxy/submit';

    if (sessionStorageRecordId) {
      data.RecordId = sessionStorageRecordId;
    }
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Embed-PublicKey': window.PREQUAL_EMBED.publicKey,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) throw new Error(`API error: ${response.status}`);

      const result = await response.json();
      const isDevEnv =
        window.PREQUAL_EMBED?.api === 'localhost' ||
        (window.PREQUAL_EMBED?.api || '').includes('scandiastaging.com');
      let debug = getQueryParam('debug');
      if (debug && isDevEnv) {
        document.querySelector('.request').innerHTML =
          `<pre>REQUEST${JSON.stringify(result.request, null, 2)}</pre>`;
        document.querySelector('.response').innerHTML =
          `<pre>RESPONSE${JSON.stringify(JSON.parse(result.result), null, 2)}</pre>`;
      }
      if (result.RecordId) sessionStorage.setItem('UmbracoFormsRecordId');
      return result;
    } catch (error) {
      showWidgetError(
        widget.querySelector('.tab-content'),
        'An error occurred while processing data. Please try again later.'
      );
      reportErrorToServer('submitEntryToUmbracoForms', error);
      console.error('Error fetching loan options:', error);
      return null;
    } finally {
    }
  };

  const fetchData = async () => {
    hideWidgetError();
    const formData = new FormData(form);
    const url = '//' + window.PREQUAL_EMBED.api + '/form-proxy/getloanoptions';

    const data = {
      EmbedId: window.PREQUAL_EMBED.embedId,
      Values: Object.fromEntries(formData.entries()),
    };

    try {
      AddSkeleton();
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Embed-PublicKey': window.PREQUAL_EMBED.publicKey,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) throw new Error(`API error: ${response.status}`);

      const result = await response.json();
      const isDevEnv =
        window.PREQUAL_EMBED?.api === 'localhost' ||
        (window.PREQUAL_EMBED?.api || '').includes('scandiastaging.com');
      let debug = getQueryParam('debug');
      if (debug && isDevEnv) {
        document.querySelector('.request').innerHTML =
          `<pre>REQUEST${JSON.stringify(result.request, null, 2)}</pre>`;
        document.querySelector('.response').innerHTML =
          `<pre>RESPONSE${JSON.stringify(JSON.parse(result.result), null, 2)}</pre>`;
      }
      return result;
    } catch (error) {
      showWidgetError(
        widget.querySelector('.tab-content'),
        'An error occurred while processing data. Please try again later.'
      );
      const cards = form.querySelectorAll(`[data-scenario]`);
      cards.forEach(card => {
        const drawEl = card.querySelectorAll('[data-draw-container]');
        if (drawEl) drawEl.forEach(el => (el.textContent = '-'));
        const paymentEl = card.querySelectorAll('[data-field="monthly-payment"]');
        if (paymentEl) paymentEl.forEach(el => (el.textContent = '-'));
        const subtextEl = card.querySelectorAll('[data-field="subtext"]');
        if (subtextEl) subtextEl.forEach(el => (el.textContent = 'No product available'));
      });
      reportErrorToServer('fetchData', error);
      console.error('Error fetching loan options:', error);
      return null;
    } finally {
      RemoveSkeleton();
    }
  };

  const allTabSteps = Array.from(widget.querySelectorAll('[data-bs-toggle="tab"][data-step]'));
  const maxStep = Math.max(0, ...allTabSteps.map(t => Number(t.dataset.step)));

  const fetchResults = () => {
    (async () => {
      AddSkeleton();
      try {
        const data = await submitEntryToUmbracoFormsAndFetchData();
        if (data && !data.invalidState) {
          initLoanAmountSlider(data);
          updateContactCard(data);
          updateLoanCards(JSON.parse(data.result));
        }
      } finally {
        RemoveSkeleton();
      }
    })();
  };

  // Re-asserts prequal_last_page_completed=3 on HubSpot when the results step is revisited without
  // refetching pricing (results already loaded). Keeps the field from staying regressed after a client
  // goes back to an earlier step (which bumps it down) and returns to step 3 without a fresh submit.
  const markStepThreeComplete = () => {
    const queryLeadId = getQueryParam('hs_object_id');
    if (!queryLeadId) return;
    fetch('//' + window.PREQUAL_EMBED.api + '/form-proxy/hubspot/markStepComplete', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Embed-PublicKey': window.PREQUAL_EMBED.publicKey,
      },
      body: JSON.stringify({
        EmbedId: window.PREQUAL_EMBED.embedId,
        ObjectId: queryLeadId,
      }),
    }).catch(error => {
      reportErrorToServer('markStepComplete', error);
      console.error('Error marking step 3 complete:', error);
    });
  };

  const updateTabCompletedStates = () => {
    if (!isStepsMode) return;
    const allTabs = widget.querySelectorAll('[data-bs-toggle="tab"][data-step]');
    const lastStep = allTabs.length;
    const current = Number(activeStep);
    allTabs.forEach(tabEl => {
      const step = Number(tabEl.dataset.step);
      // Still call validateStep for its side-effect of enabling/disabling the next tab button.
      validateStep(step);
      const completed = step < current || (step === lastStep && current === lastStep);
      tabEl.classList.toggle('completed', completed);
      const mobileItem = widget.querySelector(`.step-mobile-item[data-step="${step}"]`);
      if (mobileItem) {
        mobileItem.disabled = tabEl.disabled;
        mobileItem.classList.toggle('completed', completed);
      }
    });
    // Sync mobile toggle indicator: checkmark on last step, step number otherwise.
    const toggleIndicator = widget.querySelector('.step-mobile-indicator');
    if (toggleIndicator) {
      if (current === lastStep) {
        toggleIndicator.innerHTML =
          '<svg class="svg-icon svg-icon-fill icon-check-circle-fill text-primary"><use xlink:href="../images/spritemap/spritemap.svg#icon-check-circle-fill"></use></svg>';
      } else {
        toggleIndicator.textContent = String(current);
      }
    }
  };

  if (isStepsMode) {
    const tabs = widget.querySelectorAll('[data-bs-toggle="tab"][data-step]');
    const steps = widget.querySelectorAll('.tab-pane[data-step]');
    steps.forEach(stepEl => {
      const id = stepEl.id;
      const {step, stepValidation} = stepEl.dataset;
      const tab = document.querySelector(
        `[data-bs-target="#${id}"][data-bs-toggle="tab"][data-step="${step}"]`
      );

      if (stepValidation) {
        validateStep(step);
        attachValidationHandlers(stepEl, step);
      }
      if (Number(step) > 1 && tab) tab.disabled = true;
    });

    form.querySelectorAll('[data-action="changeStep"][data-step]').forEach(btn => {
      btn.addEventListener('click', e => {
        const nextStep = Number(btn.dataset.step);
        const currentStep = activeStep;

        if (nextStep > currentStep) {
          const valid = validateStep(currentStep, true);
          if (!valid) return;
        }
        showLoading();
        changeStep(nextStep);
        hideLoading();
      });
    });

    widget.addEventListener('shown.bs.tab', e => {
      const {step} = e.target.dataset;
      activeStep = Number(step);
      history.replaceState(null, '', '#step-' + step);
      window.scrollTo({top: 0, behavior: 'smooth'});
      updateTabCompletedStates();
      if (Number(step) === maxStep && getQueryParam('hs_object_id')) {
        if (!resultsLoaded) {
          if (prefillComplete) fetchResults();
          // else: deferred to prefillForm().then()
        } else {
          markStepThreeComplete();
        }
      }
    });
    widget.addEventListener('hidden.bs.tab', () => {
      updateTabCompletedStates();
    });
  } else {
    attachValidationHandlers(form);
    form.addEventListener('submit', submitForm);
  }

  function updateLoanCards(data) {
    if (!data) return;
    resultsLoaded = true;
    updateTabCompletedStates();
    const hasAnyProducts = data.some(option => option?.eligible?.products?.length > 0);
    if (hasAnyProducts) {
      noResults.classList.add('d-none');
      withResults.classList.remove('d-none');
      data.forEach(option => {
        const scenario = option.scenario;
        const card = widget.querySelector(`[data-scenario="${scenario}"]`);
        if (!card) return;
        card.classList.remove('d-none');
        if (scenario === 'FIXED_HELOC') {
          const eligible = option.eligible || {};
          const products = eligible.products || [];
          if (!products.length) {
            card.classList.add('d-none');
            return;
          }
          let productThirtyYear = null;
          let productTwentyYear = null;
          let productFifteenYear = null;
          const teaserProducts = {
            30: {},
            20: {},
            15: {},
          };
          products.forEach(product => {
            const isTeaser = product.teaserPrincipalAndInterest != null && product.teaserTermMonths != null;

            if (
              product.amortizationTerm.includes('FifteenYear') &&
              product.productName.includes('Standalone')
            ) {
              if (isTeaser) {
                teaserProducts[15][product.teaserTermMonths] = product;
              } else {
                productFifteenYear = product;
              }
            }

            if (
              product.amortizationTerm.includes('ThirtyYear') &&
              product.productName.includes('Standalone')
            ) {
              if (isTeaser) {
                teaserProducts[30][product.teaserTermMonths] = product;
              } else {
                productThirtyYear = product;
              }
            }

            if (
              product.amortizationTerm.includes('TwentyYear') &&
              product.productName.includes('Standalone')
            ) {
              if (isTeaser) {
                teaserProducts[20][product.teaserTermMonths] = product;
              } else {
                productTwentyYear = product;
              }
            }
          });

          [15, 20, 30].forEach(term => {
            const t = teaserProducts[term];

            if (t[12] && !t[24]) t[24] = t[12];
            if (t[24] && !t[12]) t[12] = t[24];
          });

          const hasTeaser =
            Object.keys(teaserProducts[30]).length > 0 ||
            Object.keys(teaserProducts[20]).length > 0 ||
            Object.keys(teaserProducts[15]).length > 0;

          const totalLoanAmount = eligible.totalLoanAmountDetails?.totalLoanAmount ?? null;
          // Draw Amount
          const defaultSubtextWrapper = card.querySelector('[data-subtext-values]');
          const teaserSubtextWrapper = card.querySelector('[data-subtext-teaser]');
          const defaultValuesWrapper = card.querySelector('[data-values-default]');
          const teaserValuesWrapper = card.querySelector('[data-values-teaser]');
          const drawWrapper = card.querySelector('[data-draw-container]');
          const termWrapper = card.querySelector('[data-term-container]');
          const termTeaserWrapper = card.querySelector('[data-term-teaser]');
          const years = termWrapper.querySelectorAll('input[type="radio"]');
          const teaserYears = termTeaserWrapper.querySelectorAll('input[type="radio"]');

          if (hasTeaser) {
            card.classList.add('has-teaser');
            termTeaserWrapper.classList.remove('d-none');
            teaserValuesWrapper.classList.remove('d-none');
            defaultValuesWrapper.classList.add('d-none');
            defaultSubtextWrapper.classList.add('d-none');
            teaserSubtextWrapper.classList.remove('d-none');
            if (isLatham) {
              card.classList.add('latham-teaser');
              const notePaymentRow = card.querySelector('[data-latham-note-payment]');
              if (notePaymentRow) notePaymentRow.classList.remove('d-none');
              drawWrapper.classList.add('d-none');
              const teaserTermRow = card.querySelector('[data-term-teaser]');
              const termRow = card.querySelector('[data-term-container]');
              if (teaserTermRow && termRow) {
                termRow.parentNode.insertBefore(teaserTermRow, termRow);
              }
              card.querySelectorAll('[data-default-disclosure]').forEach(el => el.classList.add('d-none'));
              card.querySelectorAll('[data-latham-disclosure]').forEach(el => el.classList.remove('d-none'));
              const paymentLabel = teaserValuesWrapper?.querySelector('.item-label');
              if (paymentLabel) paymentLabel.textContent = 'Monthly Introductory Payment';
            }
          } else {
            card.classList.remove('has-teaser');
            card.classList.remove('latham-teaser');
            termTeaserWrapper.classList.add('d-none');
            teaserValuesWrapper.classList.add('d-none');
            defaultValuesWrapper.classList.remove('d-none');
            defaultSubtextWrapper.classList.remove('d-none');
            teaserSubtextWrapper.classList.add('d-none');
          }

          years.forEach(year => {
            let monthlyValue;
            let parts = [];
            let originationCosts;

            if (hasTeaser) {
              teaserYears.forEach(teaserYear => {
                if (year.value == '30') {
                  const teaserProduct = teaserProducts[Number(year.value)][Number(teaserYear.value) * 12];
                  const config = {
                    lineAmount: totalLoanAmount,
                    annualRate: teaserProduct.rate,
                    drawAmount: totalLoanAmount,
                    termYears: 30,
                  };
                  originationCosts = teaserProduct?.originationCosts || 0;
                  monthlyValue =
                    teaserProduct?.teaserPrincipalAndInterest ||
                    teaserProduct?.principalAndInterest ||
                    calculateLoanProduct(scenario, config).monthlyPayment;
                  parts = [];
                  let rate = teaserProduct?.teaserRate || teaserProduct?.rate;
                  const noteRate30 = teaserProduct?.rate;
                  if (isLatham) {
                    if (rate)
                      parts.push(
                        `Introductory Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                    if (noteRate30)
                      parts.push(
                        `Note Rate: <strong>${noteRate30.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  } else {
                    if (rate)
                      parts.push(
                        `Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  }
                } else if (year.value == '20') {
                  const teaserProduct = teaserProducts[Number(year.value)][Number(teaserYear.value) * 12];
                  const teaserProduct30year = teaserProducts[30][Number(teaserYear.value) * 12];

                  let rate =
                    teaserProduct?.teaserRate ||
                    teaserProduct?.rate ||
                    teaserProduct30year?.teaserRate ||
                    teaserProduct30year?.rate;
                  const config = {
                    lineAmount: totalLoanAmount,
                    annualRate: rate,
                    drawAmount: totalLoanAmount,
                    termYears: 20,
                  };

                  originationCosts =
                    teaserProduct?.originationCosts || teaserProduct30year?.originationCosts || 0;
                  monthlyValue =
                    teaserProduct?.teaserPrincipalAndInterest ||
                    teaserProduct?.principalAndInterest ||
                    calculateLoanProduct(scenario, config).monthlyPayment;
                  parts = [];
                  const noteRate20yr = teaserProduct?.rate || teaserProduct30year?.rate;
                  if (isLatham) {
                    if (rate)
                      parts.push(
                        `Introductory Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                    if (noteRate20yr)
                      parts.push(
                        `Note Rate: <strong>${noteRate20yr.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  } else {
                    if (rate)
                      parts.push(
                        `Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  }
                } else if (year.value == '15') {
                  const teaserProduct = teaserProducts[15][Number(teaserYear.value) * 12];
                  const teaserProduct20year = teaserProducts[20][Number(teaserYear.value) * 12];
                  const teaserProduct30year = teaserProducts[30][Number(teaserYear.value) * 12];

                  let rate =
                    teaserProduct?.teaserRate ||
                    teaserProduct?.rate ||
                    teaserProduct20year?.teaserRate ||
                    teaserProduct20year?.rate ||
                    teaserProduct30year?.teaserRate ||
                    teaserProduct30year?.rate;
                  const config = {
                    lineAmount: totalLoanAmount,
                    annualRate: rate,
                    drawAmount: totalLoanAmount,
                    termYears: 15,
                  };

                  originationCosts =
                    teaserProduct?.originationCosts ||
                    teaserProduct20year?.originationCosts ||
                    teaserProduct30year?.originationCosts ||
                    0;
                  monthlyValue =
                    teaserProduct?.teaserPrincipalAndInterest ||
                    teaserProduct?.principalAndInterest ||
                    calculateLoanProduct(scenario, config).monthlyPayment;
                  parts = [];
                  const noteRate15yr =
                    teaserProduct?.rate || teaserProduct20year?.rate || teaserProduct30year?.rate;
                  if (isLatham) {
                    if (rate)
                      parts.push(
                        `Introductory Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                    if (noteRate15yr)
                      parts.push(
                        `Note Rate: <strong>${noteRate15yr.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  } else {
                    if (rate)
                      parts.push(
                        `Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  }
                } else {
                  const teaserProduct = teaserProducts[20][Number(teaserYear.value) * 12];
                  const teaserProduct20year = teaserProducts[20][Number(teaserYear.value) * 12];

                  let rate =
                    teaserProduct?.teaserRate ||
                    teaserProduct?.rate ||
                    teaserProduct20year?.teaserRate ||
                    teaserProduct20year?.rate;
                  const config = {
                    lineAmount: totalLoanAmount,
                    annualRate: rate,
                    drawAmount: totalLoanAmount,
                    termYears: 20,
                  };

                  originationCosts =
                    teaserProduct?.originationCosts || teaserProduct20year?.originationCosts || 0;
                  monthlyValue =
                    teaserProduct?.teaserPrincipalAndInterest ||
                    teaserProduct?.principalAndInterest ||
                    teaserProduct20year?.teaserPrincipalAndInterest ||
                    teaserProduct20year?.principalAndInterest ||
                    calculateLoanProduct(scenario, config).monthlyPayment;
                  parts = [];
                  const noteRateElse = teaserProduct?.rate;
                  if (isLatham) {
                    if (rate)
                      parts.push(
                        `Introductory Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                    if (noteRateElse)
                      parts.push(
                        `Note Rate: <strong>${noteRateElse.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  } else {
                    if (rate)
                      parts.push(
                        `Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  }
                }
                const termValue = card.querySelector('[data-field="term-list"] input:checked')?.value || '30';
                const termTeaserValue =
                  card.querySelector('[data-field="teaser-term-list"] input:checked')?.value || '1';
                const paymentLabels = card.querySelectorAll(
                  'data[data-value], [data-field="subtext"], [data-field="origination-costs"], [data-field="monthly-payment"]'
                );
                paymentLabels.forEach(lbl => lbl.classList.add('d-none'));
                const paymentEl = card.querySelector(
                  `[data-term="${year.value}"][data-teaser="${teaserYear.value}"][data-field="monthly-payment"]`
                );
                if (paymentEl) {
                  paymentEl.textContent =
                    monthlyValue && monthlyValue > 0
                      ? `$${monthlyValue.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}`
                      : '-';
                }
                const subtextEl = card.querySelector(
                  `[data-value="${year.value}"][data-teaser="${teaserYear.value}"][data-field="subtext"]`
                );
                if (subtextEl) {
                  subtextEl.innerHTML = parts.length ? parts.join(' | ') : 'Details not available';
                }
                const elToShow = card.querySelector(
                  `[data-term="${termValue}"][data-teaser="${termTeaserValue}"][data-field="monthly-payment"]`
                );
                if (elToShow) {
                  elToShow.classList.remove('d-none');
                }
                const subtextElToShow = card.querySelector(
                  `[data-value="${termValue}"][data-teaser="${termTeaserValue}"][data-field="subtext"]`
                );
                if (subtextElToShow) {
                  subtextElToShow.classList.remove('d-none');
                }
              });
            } else {
              if (year.value == '30') {
                const config = {
                  lineAmount: totalLoanAmount,
                  annualRate: productThirtyYear.rate,
                  drawAmount: totalLoanAmount,
                  termYears: 30,
                };
                originationCosts = productThirtyYear?.originationCosts || 0;
                monthlyValue =
                  productThirtyYear?.principalAndInterest ||
                  calculateLoanProduct(scenario, config).monthlyPayment;
                parts = [];
                if (productThirtyYear.rate)
                  parts.push(
                    `Rate: <strong>${productThirtyYear.rate.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
                if (productThirtyYear.apr)
                  parts.push(
                    `APR: <strong>${productThirtyYear.apr.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
              } else if (year.value == '20') {
                let rate = productTwentyYear?.rate || productThirtyYear.rate;
                let apr = productTwentyYear?.apr || productThirtyYear.apr;
                originationCosts =
                  productTwentyYear?.originationCosts || productThirtyYear?.originationCosts || 0;
                const config = {
                  lineAmount: totalLoanAmount,
                  annualRate: rate,
                  drawAmount: totalLoanAmount,
                  termYears: 20,
                };
                monthlyValue =
                  productTwentyYear?.principalAndInterest ||
                  calculateLoanProduct(scenario, config).monthlyPayment;
                parts = [];
                if (rate)
                  parts.push(
                    `Rate: <strong>${rate.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
                if (apr)
                  parts.push(
                    `APR: <strong>${apr.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
              } else if (year.value == '15') {
                let rate = productFifteenYear?.rate || productTwentyYear?.rate || productThirtyYear.rate;
                let apr = productFifteenYear?.apr || productTwentyYear?.apr || productThirtyYear.apr;
                originationCosts =
                  productFifteenYear?.originationCosts ||
                  productTwentyYear?.originationCosts ||
                  productThirtyYear?.originationCosts ||
                  0;
                const config = {
                  lineAmount: totalLoanAmount,
                  annualRate: rate,
                  drawAmount: totalLoanAmount,
                  termYears: 15,
                };
                monthlyValue =
                  productFifteenYear?.principalAndInterest ||
                  calculateLoanProduct(scenario, config).monthlyPayment;
                parts = [];
                if (rate)
                  parts.push(
                    `Rate: <strong>${rate.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
                if (apr)
                  parts.push(
                    `APR: <strong>${apr.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
              } else {
                let rate = productTwentyYear?.rate || productThirtyYear.rate;
                let apr = productTwentyYear?.apr || productThirtyYear.apr;
                originationCosts =
                  productTwentyYear?.originationCosts || productThirtyYear?.originationCosts || 0;
                const config = {
                  lineAmount: totalLoanAmount,
                  annualRate: rate,
                  drawAmount: totalLoanAmount,
                  termYears: Number(year.value),
                };
                monthlyValue = calculateLoanProduct(scenario, config).monthlyPayment;
                parts = [];
                if (rate)
                  parts.push(
                    `Rate: <strong>${rate.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
                if (apr)
                  parts.push(
                    `APR: <strong>${apr.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
              }
              const paymentLabels = card.querySelectorAll(
                'data[data-value], [data-field="subtext"], [data-field="origination-costs"], [data-field="monthly-payment"]'
              );
              paymentLabels.forEach(lbl => lbl.classList.add('d-none'));
              const paymentEl = card.querySelector(
                `[data-term="${year.value}"][data-field="monthly-payment"]`
              );
              if (paymentEl) {
                paymentEl.classList.remove('d-none');
                paymentEl.textContent =
                  monthlyValue && monthlyValue > 0
                    ? `$${monthlyValue.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`
                    : '-';
              }
              const subtextEl = card.querySelector(`[data-value="${year.value}"][data-field="subtext"]`);
              if (subtextEl) {
                subtextEl.classList.remove('d-none');
                subtextEl.innerHTML = parts.length ? parts.join(' | ') : 'Details not available';
              }
            }

            const originCostEl = card.querySelector(
              `[data-value="${year.value}"][data-field="origination-costs"]`
            );
            if (originCostEl) {
              originCostEl.classList.remove('d-none');
              originCostEl.textContent = `$${originationCosts.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`;
            }
          });

          if (isLatham && hasTeaser) {
            const termValue = card.querySelector('[data-field="term-list"] input:checked')?.value || '30';
            years.forEach(year => {
              const termProducts = teaserProducts[Number(year.value)];
              if (!termProducts) return;
              const teaserProduct = termProducts[12] || termProducts[24];
              if (!teaserProduct) return;
              const notePayment =
                teaserProduct.principalAndInterest ||
                (teaserProduct.rate && totalLoanAmount
                  ? (teaserProduct.rate / 100 / 12) * totalLoanAmount
                  : null);
              const notePaymentEl = card.querySelector(
                `[data-latham-note-payment] [data-term="${year.value}"][data-field="note-payment"]`
              );
              if (notePaymentEl) {
                notePaymentEl.textContent =
                  notePayment && notePayment > 0
                    ? `$${notePayment.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`
                    : '$-';
                notePaymentEl.classList.toggle('d-none', year.value !== termValue);
              }
              const teaserPmt = teaserProduct.teaserPrincipalAndInterest;
              const teaserMonths = teaserProduct.teaserTermMonths;
              if (teaserPmt && teaserMonths && notePayment) {
                const remainingMonths = Number(year.value) * 12 - teaserMonths;
                const totalPmt = teaserPmt * teaserMonths + notePayment * remainingMonths;
                const totalEl = card.querySelector(
                  `[data-latham-disclosure] [data-term="${year.value}"][data-field="latham-disclosure-total"]`
                );
                if (totalEl)
                  totalEl.textContent = `$${totalPmt.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
              }
            });
            card.querySelectorAll('[data-latham-disclosure] [data-term]').forEach(el => {
              el.classList.toggle('d-none', el.dataset.term !== termValue);
            });
          }

          const dataDrawn = drawWrapper.querySelector('.min-draw-amount');

          if (dataDrawn) {
            dataDrawn.textContent = totalLoanAmount
              ? `$${totalLoanAmount.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              : '$-';
          }
        } else if (scenario === 'HELOAN') {
          if (isLatham) {
            card.classList.add('d-none');
            return;
          }
          const eligible = option.eligible || {};
          const products = eligible.products || [];
          if (!products.length) {
            card.classList.add('d-none');
            return;
          }
          let productThirtyYear = null;
          let productTwentyYear = null;
          let productFifteenYear = null;
          const teaserProducts = {
            30: {},
            20: {},
            15: {},
          };
          products.forEach(product => {
            const isTeaser = product.teaserPrincipalAndInterest != null && product.teaserTermMonths != null;

            if (
              product.amortizationTerm.includes('FifteenYear') &&
              product.productName.includes('Standalone')
            ) {
              if (isTeaser) {
                teaserProducts[15][product.teaserTermMonths] = product;
              } else {
                productFifteenYear = product;
              }
            }

            if (
              product.amortizationTerm.includes('ThirtyYear') &&
              product.productName.includes('Standalone')
            ) {
              if (isTeaser) {
                teaserProducts[30][product.teaserTermMonths] = product;
              } else {
                productThirtyYear = product;
              }
            }

            if (
              product.amortizationTerm.includes('TwentyYear') &&
              product.productName.includes('Standalone')
            ) {
              if (isTeaser) {
                teaserProducts[20][product.teaserTermMonths] = product;
              } else {
                productTwentyYear = product;
              }
            }
          });

          [15, 20, 30].forEach(term => {
            const t = teaserProducts[term];

            if (t[12] && !t[24]) t[24] = t[12];
            if (t[24] && !t[12]) t[12] = t[24];
          });

          const hasTeaser =
            Object.keys(teaserProducts[30]).length > 0 ||
            Object.keys(teaserProducts[20]).length > 0 ||
            Object.keys(teaserProducts[15]).length > 0;

          const totalLoanAmount = eligible.totalLoanAmountDetails?.totalLoanAmount ?? null;

          const defaultSubtextWrapper = card.querySelector('[data-subtext-values]');
          const teaserSubtextWrapper = card.querySelector('[data-subtext-teaser]');
          const defaultValuesWrapper = card.querySelector('[data-values-default]');
          const teaserValuesWrapper = card.querySelector('[data-values-teaser]');
          const drawWrapper = card.querySelector('[data-draw-container]');
          const termWrapper = card.querySelector('[data-term-container]');
          const termTeaserWrapper = card.querySelector('[data-term-teaser]');
          const years = termWrapper.querySelectorAll('input[type="radio"]');
          const teaserYears = termTeaserWrapper.querySelectorAll('input[type="radio"]');

          if (hasTeaser) {
            card.classList.add('has-teaser');
            termTeaserWrapper.classList.remove('d-none');
            teaserValuesWrapper.classList.remove('d-none');
            defaultValuesWrapper.classList.add('d-none');
            defaultSubtextWrapper.classList.add('d-none');
            teaserSubtextWrapper.classList.remove('d-none');
          } else {
            card.classList.remove('has-teaser');
            termTeaserWrapper.classList.add('d-none');
            teaserValuesWrapper.classList.add('d-none');
            defaultValuesWrapper.classList.remove('d-none');
            defaultSubtextWrapper.classList.remove('d-none');
            teaserSubtextWrapper.classList.add('d-none');
          }

          years.forEach(year => {
            let monthlyValue;
            let parts = [];
            let originationCosts;

            if (hasTeaser) {
              teaserYears.forEach(teaserYear => {
                if (year.value == '30') {
                  const teaserProduct = teaserProducts[Number(year.value)][Number(teaserYear.value) * 12];
                  const config = {
                    principal: totalLoanAmount,
                    annualRate: teaserProduct.rate,
                    termYears: 30,
                  };
                  originationCosts = teaserProduct?.originationCosts || 0;
                  monthlyValue =
                    teaserProduct?.teaserPrincipalAndInterest ||
                    teaserProduct?.principalAndInterest ||
                    calculateLoanProduct(scenario, config).monthlyPayment;
                  parts = [];
                  let rate = teaserProduct?.teaserRate || teaserProduct?.rate;
                  const noteRate30 = teaserProduct?.rate;
                  if (isLatham) {
                    if (rate)
                      parts.push(
                        `Introductory Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                    if (noteRate30)
                      parts.push(
                        `Note Rate: <strong>${noteRate30.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  } else {
                    if (rate)
                      parts.push(
                        `Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  }
                } else if (year.value == '20') {
                  const teaserProduct = teaserProducts[Number(year.value)][Number(teaserYear.value) * 12];
                  const teaserProduct30year = teaserProducts[30][Number(teaserYear.value) * 12];

                  let rate =
                    teaserProduct?.teaserRate ||
                    teaserProduct?.rate ||
                    teaserProduct30year?.teaserRate ||
                    teaserProduct30year?.rate;
                  const config = {
                    principal: totalLoanAmount,
                    annualRate: rate,
                    termYears: 20,
                  };

                  originationCosts =
                    teaserProduct?.originationCosts || teaserProduct30year?.originationCosts || 0;
                  monthlyValue =
                    teaserProduct?.teaserPrincipalAndInterest ||
                    teaserProduct?.principalAndInterest ||
                    calculateLoanProduct(scenario, config).monthlyPayment;
                  parts = [];
                  const noteRate20yr = teaserProduct?.rate || teaserProduct30year?.rate;
                  if (isLatham) {
                    if (rate)
                      parts.push(
                        `Introductory Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                    if (noteRate20yr)
                      parts.push(
                        `Note Rate: <strong>${noteRate20yr.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  } else {
                    if (rate)
                      parts.push(
                        `Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  }
                } else if (year.value == '15') {
                  const teaserProduct = teaserProducts[15][Number(teaserYear.value) * 12];
                  const teaserProduct20year = teaserProducts[20][Number(teaserYear.value) * 12];
                  const teaserProduct30year = teaserProducts[30][Number(teaserYear.value) * 12];

                  let rate =
                    teaserProduct?.teaserRate ||
                    teaserProduct?.rate ||
                    teaserProduct20year?.teaserRate ||
                    teaserProduct20year?.rate ||
                    teaserProduct30year?.teaserRate ||
                    teaserProduct30year?.rate;
                  const config = {
                    principal: totalLoanAmount,
                    annualRate: rate,
                    termYears: 15,
                  };

                  originationCosts =
                    teaserProduct?.originationCosts ||
                    teaserProduct20year?.originationCosts ||
                    teaserProduct30year?.originationCosts ||
                    0;
                  monthlyValue =
                    teaserProduct?.teaserPrincipalAndInterest ||
                    teaserProduct?.principalAndInterest ||
                    calculateLoanProduct(scenario, config).monthlyPayment;
                  parts = [];
                  const noteRate15yr =
                    teaserProduct?.rate || teaserProduct20year?.rate || teaserProduct30year?.rate;
                  if (isLatham) {
                    if (rate)
                      parts.push(
                        `Introductory Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                    if (noteRate15yr)
                      parts.push(
                        `Note Rate: <strong>${noteRate15yr.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  } else {
                    if (rate)
                      parts.push(
                        `Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  }
                } else {
                  const teaserProduct = teaserProducts[20][Number(teaserYear.value) * 12];
                  const teaserProduct20year = teaserProducts[20][Number(teaserYear.value) * 12];

                  let rate =
                    teaserProduct?.teaserRate ||
                    teaserProduct?.rate ||
                    teaserProduct20year?.teaserRate ||
                    teaserProduct20year?.rate;
                  const config = {
                    principal: totalLoanAmount,
                    annualRate: rate,
                    termYears: 20,
                  };

                  originationCosts =
                    teaserProduct?.originationCosts || teaserProduct20year?.originationCosts || 0;
                  monthlyValue =
                    teaserProduct?.teaserPrincipalAndInterest ||
                    teaserProduct?.principalAndInterest ||
                    teaserProduct20year?.teaserPrincipalAndInterest ||
                    teaserProduct20year?.principalAndInterest ||
                    calculateLoanProduct(scenario, config).monthlyPayment;
                  parts = [];
                  const noteRateElse = teaserProduct?.rate;
                  if (isLatham) {
                    if (rate)
                      parts.push(
                        `Introductory Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                    if (noteRateElse)
                      parts.push(
                        `Note Rate: <strong>${noteRateElse.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  } else {
                    if (rate)
                      parts.push(
                        `Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  }
                }
                const paymentLabels = card.querySelectorAll(
                  'data[data-value], [data-field="subtext"], [data-field="origination-costs"], [data-field="monthly-payment"]'
                );
                paymentLabels.forEach(lbl => lbl.classList.add('d-none'));
                const paymentEl = card.querySelector(
                  `[data-term="${year.value}"][data-teaser="${teaserYear.value}"][data-field="monthly-payment"]`
                );
                if (paymentEl) {
                  paymentEl.classList.remove('d-none');
                  paymentEl.textContent =
                    monthlyValue && monthlyValue > 0
                      ? `$${monthlyValue.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}`
                      : '-';
                }
                const subtextEl = card.querySelector(
                  `[data-value="${year.value}"][data-teaser="${teaserYear.value}"][data-field="subtext"]`
                );
                if (subtextEl) {
                  subtextEl.classList.remove('d-none');
                  subtextEl.innerHTML = parts.length ? parts.join(' | ') : 'Details not available';
                }
              });
            } else {
              if (year.value == '30') {
                const config = {
                  principal: totalLoanAmount,
                  annualRate: productThirtyYear.rate,
                  termYears: 30,
                };
                originationCosts = productThirtyYear?.originationCosts || 0;
                monthlyValue =
                  productThirtyYear?.principalAndInterest ||
                  calculateLoanProduct(scenario, config).monthlyPayment;
                parts = [];
                if (productThirtyYear.rate)
                  parts.push(
                    `Rate: <strong>${productThirtyYear.rate.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
                if (productThirtyYear.apr)
                  parts.push(
                    `APR: <strong>${productThirtyYear.apr.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
              } else if (year.value == '20') {
                let rate = productTwentyYear?.rate || productThirtyYear.rate;
                let apr = productTwentyYear?.apr || productThirtyYear.apr;
                originationCosts =
                  productTwentyYear?.originationCosts || productThirtyYear?.originationCosts || 0;
                const config = {
                  principal: totalLoanAmount,
                  annualRate: rate,
                  termYears: 20,
                };
                monthlyValue =
                  productTwentyYear?.principalAndInterest ||
                  calculateLoanProduct(scenario, config).monthlyPayment;
                parts = [];
                if (rate)
                  parts.push(
                    `Rate: <strong>${rate.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
                if (apr)
                  parts.push(
                    `APR: <strong>${apr.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
              } else if (year.value == '15') {
                let rate = productFifteenYear?.rate || productTwentyYear?.rate || productThirtyYear.rate;
                let apr = productFifteenYear?.apr || productTwentyYear?.apr || productThirtyYear.apr;
                originationCosts =
                  productFifteenYear?.originationCosts ||
                  productTwentyYear?.originationCosts ||
                  productThirtyYear?.originationCosts ||
                  0;
                const config = {
                  principal: totalLoanAmount,
                  annualRate: rate,
                  termYears: 15,
                };
                monthlyValue =
                  productFifteenYear?.principalAndInterest ||
                  calculateLoanProduct(scenario, config).monthlyPayment;
                parts = [];
                if (rate)
                  parts.push(
                    `Rate: <strong>${rate.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
                if (apr)
                  parts.push(
                    `APR: <strong>${apr.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
              } else {
                let rate = productTwentyYear?.rate || productThirtyYear.rate;
                let apr = productTwentyYear?.apr || productThirtyYear.apr;
                originationCosts =
                  productTwentyYear?.originationCosts || productThirtyYear?.originationCosts || 0;
                const config = {
                  principal: totalLoanAmount,
                  annualRate: rate,
                  termYears: Number(year.value),
                };
                monthlyValue = calculateLoanProduct(scenario, config).monthlyPayment;
                parts = [];
                if (rate)
                  parts.push(
                    `Rate: <strong>${rate.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
                if (apr)
                  parts.push(
                    `APR: <strong>${apr.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
              }
              const paymentLabels = card.querySelectorAll(
                'data[data-value], [data-field="subtext"], [data-field="origination-costs"], [data-field="monthly-payment"]'
              );
              paymentLabels.forEach(lbl => lbl.classList.add('d-none'));
              const paymentEl = card.querySelector(
                `[data-term="${year.value}"][data-field="monthly-payment"]`
              );
              if (paymentEl) {
                paymentEl.classList.remove('d-none');
                paymentEl.textContent =
                  monthlyValue && monthlyValue > 0
                    ? `$${monthlyValue.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`
                    : '-';
              }
              const subtextEl = card.querySelector(`[data-value="${year.value}"][data-field="subtext"]`);
              if (subtextEl) {
                subtextEl.classList.remove('d-none');
                subtextEl.innerHTML = parts.length ? parts.join(' | ') : 'Details not available';
              }
            }

            const originCostEl = card.querySelector(
              `[data-value="${year.value}"][data-field="origination-costs"]`
            );
            if (originCostEl) {
              originCostEl.classList.remove('d-none');
              originCostEl.textContent = `$${originationCosts.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`;
            }
          });
        } else if (scenario === 'VARIABLE_HELOC') {
          const eligible = option.eligible || {};
          const products = eligible.products || [];
          if (!products.length) {
            card.classList.add('d-none');
            return;
          }
          let productThirtyYear = null;
          let productTwentyYear = null;
          let productFifteenYear = null;
          const teaserProducts = {
            30: {},
            20: {},
            15: {},
          };
          products.forEach(product => {
            const isTeaser = product.teaserPrincipalAndInterest != null && product.teaserTermMonths != null;

            if (
              product.amortizationTerm.includes('FifteenYear') &&
              product.productName.includes('Standalone')
            ) {
              if (isTeaser) {
                teaserProducts[15][product.teaserTermMonths] = product;
              } else {
                productFifteenYear = product;
              }
            }

            if (
              product.amortizationTerm.includes('ThirtyYear') &&
              product.productName.includes('Standalone')
            ) {
              if (isTeaser) {
                teaserProducts[30][product.teaserTermMonths] = product;
              } else {
                productThirtyYear = product;
              }
            }

            if (
              product.amortizationTerm.includes('TwentyYear') &&
              product.productName.includes('Standalone')
            ) {
              if (isTeaser) {
                teaserProducts[20][product.teaserTermMonths] = product;
              } else {
                productTwentyYear = product;
              }
            }
          });

          [15, 20, 30].forEach(term => {
            const t = teaserProducts[term];

            if (t[12] && !t[24]) t[24] = t[12];
            if (t[24] && !t[12]) t[12] = t[24];
          });

          const hasTeaser =
            Object.keys(teaserProducts[30]).length > 0 ||
            Object.keys(teaserProducts[20]).length > 0 ||
            Object.keys(teaserProducts[15]).length > 0;
          const totalLoanAmount = eligible.totalLoanAmountDetails?.totalLoanAmount ?? null;
          // Draw Amount
          const defaultSubtextWrapper = card.querySelector('[data-subtext-values]');
          const teaserSubtextWrapper = card.querySelector('[data-subtext-teaser]');
          const defaultValuesWrapper = card.querySelector('[data-values-default]');
          const teaserValuesWrapper = card.querySelector('[data-values-teaser]');
          const drawWrapper = card.querySelector('[data-draw-container]');
          const termWrapper = card.querySelector('[data-term-container]');
          const termTeaserWrapper = card.querySelector('[data-term-teaser]');
          const years = termWrapper.querySelectorAll('input[type="radio"]');
          const teaserYears = termTeaserWrapper.querySelectorAll('input[type="radio"]');

          if (hasTeaser) {
            card.classList.add('has-teaser');
            termTeaserWrapper.classList.remove('d-none');
            teaserValuesWrapper.classList.remove('d-none');
            defaultValuesWrapper.classList.add('d-none');
            defaultSubtextWrapper.classList.add('d-none');
            teaserSubtextWrapper.classList.remove('d-none');
            if (isLatham) {
              card.classList.add('latham-teaser');
              const notePaymentRow = card.querySelector('[data-latham-note-payment]');
              if (notePaymentRow) notePaymentRow.classList.remove('d-none');
              drawWrapper.classList.add('d-none');
              const teaserTermRow = card.querySelector('[data-term-teaser]');
              const termRow = card.querySelector('[data-term-container]');
              if (teaserTermRow && termRow) {
                termRow.parentNode.insertBefore(teaserTermRow, termRow);
              }
              card.querySelectorAll('[data-default-disclosure]').forEach(el => el.classList.add('d-none'));
              card.querySelectorAll('[data-latham-disclosure]').forEach(el => el.classList.remove('d-none'));
              const paymentLabel = teaserValuesWrapper?.querySelector('.item-label');
              if (paymentLabel) paymentLabel.textContent = 'Monthly Introductory Payment';
            }
          } else {
            card.classList.remove('has-teaser');
            card.classList.remove('latham-teaser');
            termTeaserWrapper.classList.add('d-none');
            teaserValuesWrapper.classList.add('d-none');
            defaultValuesWrapper.classList.remove('d-none');
            defaultSubtextWrapper.classList.remove('d-none');
            teaserSubtextWrapper.classList.add('d-none');
          }

          years.forEach(year => {
            let monthlyValue;
            let parts = [];
            let originationCosts;
            if (hasTeaser) {
              teaserYears.forEach(teaserYear => {
                if (year.value == '30') {
                  const teaserProduct = teaserProducts[Number(year.value)][Number(teaserYear.value) * 12];
                  const config = {
                    lineAmount: totalLoanAmount,
                    annualRate: teaserProduct.rate,
                    drawAmount: totalLoanAmount,
                    termYears: 30,
                  };
                  originationCosts = teaserProduct?.originationCosts || 0;
                  monthlyValue =
                    teaserProduct?.teaserPrincipalAndInterest ||
                    teaserProduct?.principalAndInterest ||
                    calculateLoanProduct(scenario, config).monthlyPayment;
                  parts = [];
                  let rate = teaserProduct?.teaserRate || teaserProduct?.rate;
                  const noteRate30 = teaserProduct?.rate;
                  if (isLatham) {
                    if (rate)
                      parts.push(
                        `Introductory Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                    if (noteRate30)
                      parts.push(
                        `Note Rate: <strong>${noteRate30.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  } else {
                    if (rate)
                      parts.push(
                        `Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  }
                } else if (year.value == '20') {
                  const teaserProduct = teaserProducts[Number(year.value)][Number(teaserYear.value) * 12];
                  const teaserProduct30year = teaserProducts[30][Number(teaserYear.value) * 12];

                  let rate =
                    teaserProduct?.teaserRate ||
                    teaserProduct?.rate ||
                    teaserProduct30year?.teaserRate ||
                    teaserProduct30year?.rate;
                  const config = {
                    lineAmount: totalLoanAmount,
                    annualRate: rate,
                    drawAmount: totalLoanAmount,
                    termYears: 20,
                  };

                  originationCosts =
                    teaserProduct?.originationCosts || teaserProduct30year?.originationCosts || 0;
                  monthlyValue =
                    teaserProduct?.teaserPrincipalAndInterest ||
                    teaserProduct?.principalAndInterest ||
                    calculateLoanProduct(scenario, config).monthlyPayment;
                  parts = [];
                  const noteRate20yr = teaserProduct?.rate || teaserProduct30year?.rate;
                  if (isLatham) {
                    if (rate)
                      parts.push(
                        `Introductory Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                    if (noteRate20yr)
                      parts.push(
                        `Note Rate: <strong>${noteRate20yr.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  } else {
                    if (rate)
                      parts.push(
                        `Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  }
                } else if (year.value == '15') {
                  const teaserProduct = teaserProducts[15][Number(teaserYear.value) * 12];
                  const teaserProduct20year = teaserProducts[20][Number(teaserYear.value) * 12];
                  const teaserProduct30year = teaserProducts[30][Number(teaserYear.value) * 12];

                  let rate =
                    teaserProduct?.teaserRate ||
                    teaserProduct?.rate ||
                    teaserProduct20year?.teaserRate ||
                    teaserProduct20year?.rate ||
                    teaserProduct30year?.teaserRate ||
                    teaserProduct30year?.rate;
                  const config = {
                    lineAmount: totalLoanAmount,
                    annualRate: rate,
                    drawAmount: totalLoanAmount,
                    termYears: 15,
                  };

                  originationCosts =
                    teaserProduct?.originationCosts ||
                    teaserProduct20year?.originationCosts ||
                    teaserProduct30year?.originationCosts ||
                    0;
                  monthlyValue =
                    teaserProduct?.teaserPrincipalAndInterest ||
                    teaserProduct?.principalAndInterest ||
                    calculateLoanProduct(scenario, config).monthlyPayment;
                  parts = [];
                  const noteRate15yr =
                    teaserProduct?.rate || teaserProduct20year?.rate || teaserProduct30year?.rate;
                  if (isLatham) {
                    if (rate)
                      parts.push(
                        `Introductory Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                    if (noteRate15yr)
                      parts.push(
                        `Note Rate: <strong>${noteRate15yr.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  } else {
                    if (rate)
                      parts.push(
                        `Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  }
                } else {
                  const teaserProduct = teaserProducts[20][Number(teaserYear.value) * 12];
                  const teaserProduct20year = teaserProducts[20][Number(teaserYear.value) * 12];

                  let rate =
                    teaserProduct?.teaserRate ||
                    teaserProduct?.rate ||
                    teaserProduct20year?.teaserRate ||
                    teaserProduct20year?.rate;
                  const config = {
                    lineAmount: totalLoanAmount,
                    annualRate: rate,
                    drawAmount: totalLoanAmount,
                    termYears: 20,
                  };

                  originationCosts =
                    teaserProduct?.originationCosts || teaserProduct20year?.originationCosts || 0;
                  monthlyValue =
                    teaserProduct?.teaserPrincipalAndInterest ||
                    teaserProduct?.principalAndInterest ||
                    teaserProduct20year?.teaserPrincipalAndInterest ||
                    teaserProduct20year?.principalAndInterest ||
                    calculateLoanProduct(scenario, config).monthlyPayment;
                  parts = [];
                  const noteRateElse = teaserProduct?.rate;
                  if (isLatham) {
                    if (rate)
                      parts.push(
                        `Introductory Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                    if (noteRateElse)
                      parts.push(
                        `Note Rate: <strong>${noteRateElse.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  } else {
                    if (rate)
                      parts.push(
                        `Rate: <strong>${rate.toLocaleString(undefined, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        })}%</strong>`
                      );
                  }
                }
                const termValue = card.querySelector('[data-field="term-list"] input:checked')?.value || '30';
                const termTeaserValue =
                  card.querySelector('[data-field="teaser-term-list"] input:checked')?.value || '1';

                const paymentLabels = card.querySelectorAll(
                  'data[data-value], [data-field="subtext"], [data-field="origination-costs"], [data-field="monthly-payment"]'
                );
                paymentLabels.forEach(lbl => lbl.classList.add('d-none'));
                const paymentEl = card.querySelector(
                  `[data-term="${year.value}"][data-teaser="${teaserYear.value}"][data-field="monthly-payment"]`
                );
                const elToShow = card.querySelector(
                  `[data-term="${termValue}"][data-teaser="${termTeaserValue}"][data-field="monthly-payment"]`
                );
                if (paymentEl) {
                  paymentEl.textContent =
                    monthlyValue && monthlyValue > 0
                      ? `$${monthlyValue.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}`
                      : '-';
                }
                if (elToShow) {
                  elToShow.classList.remove('d-none');
                }
                const subtextEl = card.querySelector(
                  `[data-value="${year.value}"][data-teaser="${teaserYear.value}"][data-field="subtext"]`
                );
                const subtextElToShow = card.querySelector(
                  `[data-value="${termValue}"][data-teaser="${termTeaserValue}"][data-field="subtext"]`
                );
                if (subtextEl) {
                  subtextEl.innerHTML = parts.length ? parts.join(' | ') : 'Details not available';
                }
                if (subtextElToShow) {
                  subtextElToShow.classList.remove('d-none');
                }
              });
            } else {
              if (year.value == '30') {
                const config = {
                  lineAmount: totalLoanAmount,
                  annualRate: productThirtyYear.rate,
                  drawAmount: totalLoanAmount,
                  termYears: 30,
                };
                originationCosts = productThirtyYear?.originationCosts || 0;
                monthlyValue =
                  productThirtyYear?.principalAndInterest ||
                  calculateLoanProduct(scenario, config).monthlyPayment;
                parts = [];
                if (productThirtyYear.rate)
                  parts.push(
                    `Rate: <strong>${productThirtyYear.rate.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
                if (productThirtyYear.apr)
                  parts.push(
                    `APR: <strong>${productThirtyYear.apr.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
              } else if (year.value == '20') {
                let rate = productTwentyYear?.rate || productThirtyYear.rate;
                let apr = productTwentyYear?.apr || productThirtyYear.apr;
                const config = {
                  lineAmount: totalLoanAmount,
                  annualRate: rate,
                  drawAmount: totalLoanAmount,
                  termYears: 20,
                };
                originationCosts =
                  productTwentyYear?.originationCosts || productThirtyYear?.originationCosts || 0;
                monthlyValue =
                  productTwentyYear?.principalAndInterest ||
                  calculateLoanProduct(scenario, config).monthlyPayment;
                parts = [];
                if (rate)
                  parts.push(
                    `Rate: <strong>${rate.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
                if (apr)
                  parts.push(
                    `APR: <strong>${apr.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
              } else if (year.value == '15') {
                let rate = productFifteenYear?.rate || productTwentyYear?.rate || productThirtyYear.rate;
                let apr = productFifteenYear?.apr || productTwentyYear?.apr || productThirtyYear.apr;
                const config = {
                  lineAmount: totalLoanAmount,
                  annualRate: rate,
                  drawAmount: totalLoanAmount,
                  termYears: 15,
                };
                originationCosts =
                  productFifteenYear?.originationCosts ||
                  productTwentyYear?.originationCosts ||
                  productThirtyYear?.originationCosts ||
                  0;
                monthlyValue =
                  productFifteenYear?.principalAndInterest ||
                  calculateLoanProduct(scenario, config).monthlyPayment;
                parts = [];
                if (rate)
                  parts.push(
                    `Rate: <strong>${rate.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
                if (apr)
                  parts.push(
                    `APR: <strong>${apr.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
              } else {
                let rate = productTwentyYear?.rate || productThirtyYear.rate;
                let apr = productTwentyYear?.apr || productThirtyYear.apr;
                const config = {
                  lineAmount: totalLoanAmount,
                  annualRate: rate,
                  drawAmount: totalLoanAmount,
                  termYears: Number(year.value),
                };
                originationCosts =
                  productTwentyYear?.originationCosts || productThirtyYear?.originationCosts || 0;
                monthlyValue = calculateLoanProduct(scenario, config).monthlyPayment;
                parts = [];
                if (rate)
                  parts.push(
                    `Rate: <strong>${rate.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
                if (apr)
                  parts.push(
                    `APR: <strong>${apr.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}%</strong>`
                  );
              }
              const paymentLabels = card.querySelectorAll(
                'data[data-value], [data-field="subtext"], [data-field="origination-costs"], [data-field="monthly-payment"]'
              );
              paymentLabels.forEach(lbl => lbl.classList.add('d-none'));
              const paymentEl = card.querySelector(
                `[data-term="${year.value}"][data-field="monthly-payment"]`
              );
              if (paymentEl) {
                paymentEl.classList.remove('d-none');
                paymentEl.textContent =
                  monthlyValue && monthlyValue > 0
                    ? `$${monthlyValue.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`
                    : '-';
              }
              const subtextEl = card.querySelector(`[data-value="${year.value}"][data-field="subtext"]`);
              if (subtextEl) {
                subtextEl.classList.remove('d-none');
                subtextEl.innerHTML = parts.length ? parts.join(' | ') : 'Details not available';
              }
            }

            const originCostEl = card.querySelector(
              `[data-value="${year.value}"][data-field="origination-costs"]`
            );
            if (originCostEl) {
              originCostEl.textContent = `$${originationCosts.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`;
            }
          });

          if (isLatham && hasTeaser) {
            const termValue = card.querySelector('[data-field="term-list"] input:checked')?.value || '30';
            years.forEach(year => {
              const termProducts = teaserProducts[Number(year.value)];
              if (!termProducts) return;
              const teaserProduct = termProducts[12] || termProducts[24];
              if (!teaserProduct) return;
              const notePayment =
                teaserProduct.principalAndInterest ||
                (teaserProduct.rate && totalLoanAmount
                  ? (teaserProduct.rate / 100 / 12) * totalLoanAmount
                  : null);
              const notePaymentEl = card.querySelector(
                `[data-latham-note-payment] [data-term="${year.value}"][data-field="note-payment"]`
              );
              if (notePaymentEl) {
                notePaymentEl.textContent =
                  notePayment && notePayment > 0
                    ? `$${notePayment.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`
                    : '$-';
                notePaymentEl.classList.toggle('d-none', year.value !== termValue);
              }
              const teaserPmt = teaserProduct.teaserPrincipalAndInterest;
              const teaserMonths = teaserProduct.teaserTermMonths;
              if (teaserPmt && teaserMonths && notePayment) {
                const remainingMonths = Number(year.value) * 12 - teaserMonths;
                const totalLow = teaserPmt * teaserMonths + notePayment * remainingMonths;
                const capPayment = totalLoanAmount ? (18 / 100 / 12) * totalLoanAmount : null;
                const lowEl = card.querySelector(
                  `[data-latham-disclosure] [data-term="${year.value}"][data-field="latham-disclosure-total-low"]`
                );
                const highEl = card.querySelector(
                  `[data-latham-disclosure] [data-term="${year.value}"][data-field="latham-disclosure-total-high"]`
                );
                if (lowEl)
                  lowEl.textContent = `$${totalLow.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                if (highEl && capPayment) {
                  const totalHigh = teaserPmt * teaserMonths + capPayment * remainingMonths;
                  highEl.textContent = `$${totalHigh.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                }
              }
            });
            card.querySelectorAll('[data-latham-disclosure] [data-term]').forEach(el => {
              el.classList.toggle('d-none', el.dataset.term !== termValue);
            });
          }

          const dataDrawn = drawWrapper.querySelector('.min-draw-amount');

          if (dataDrawn) {
            dataDrawn.textContent = totalLoanAmount
              ? `$${totalLoanAmount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`
              : '$-';
          }
        }
      });

      const visibleCards = Array.from(cards).filter(card => !card.classList.contains('d-none'));
      visibleCards.forEach(card => {
        const paymentEls = card.querySelectorAll('[data-field="monthly-payment"]:not(.d-none)');
        const payments = Array.from(paymentEls).map(el => {
          const text = el.textContent.replace(/[$,]/g, '');
          return parseFloat(text) || Infinity;
        });
        card._minPayment = Math.min(...payments);
      });
      visibleCards.sort((a, b) => a._minPayment - b._minPayment);
      // Reorder in DOM
      const parent = visibleCards[0]?.parentElement;
      if (parent) {
        visibleCards.forEach(card => {
          parent.appendChild(card);
        });
      }
    } else {
      noResults.classList.remove('d-none');
      withResults.classList.add('d-none');
      cards.forEach(card => {
        card.classList.add('d-none');
      });
    }
  }

  function calculateMortgage(principal, annualRate, termYears) {
    const monthlyRate = annualRate / 100 / 12;
    const n = termYears * 12;

    if (monthlyRate === 0) {
      return principal / n; // 0% interest edge case
    }

    const numerator = monthlyRate * Math.pow(1 + monthlyRate, n);
    const denominator = Math.pow(1 + monthlyRate, n) - 1;

    return principal * (numerator / denominator);
  }

  /**
   * VARIABLE_HELOC – interest-only payment with min/max draw.
   */
  function calculateVariableHELOC(lineAmount, drawAmount, annualRate) {
    const MIN_DRAW = 25000;

    let appliedDraw = drawAmount;

    if (appliedDraw < MIN_DRAW) {
      appliedDraw = MIN_DRAW;
    } else if (appliedDraw > lineAmount) {
      appliedDraw = lineAmount;
    }

    const monthlyRate = annualRate / 100 / 12;
    const payment = appliedDraw * monthlyRate;

    let note = '';
    if (drawAmount < MIN_DRAW) note = `Draw amount increased to minimum of $${MIN_DRAW}.`;
    if (drawAmount > lineAmount) note = `Draw amount reduced to maximum line amount of $${lineAmount}.`;

    return {
      payment,
      appliedDraw,
      note,
    };
  }

  /**
   * FIXED_HELOC – amortizing payment with min/max draw.
   */
  function calculateFixedHELOC(lineAmount, drawAmount, annualRate, termYears) {
    const MIN_DRAW = 25000;

    let appliedDraw = drawAmount;

    if (appliedDraw < MIN_DRAW) {
      appliedDraw = MIN_DRAW;
    } else if (appliedDraw > lineAmount) {
      appliedDraw = lineAmount;
    }

    const monthlyRate = annualRate / 100 / 12;
    const n = termYears * 12;

    let payment;
    if (monthlyRate === 0) {
      payment = appliedDraw / n; // 0% interest edge case
    } else {
      const numerator = monthlyRate * Math.pow(1 + monthlyRate, n);
      const denominator = Math.pow(1 + monthlyRate, n) - 1;
      payment = appliedDraw * (numerator / denominator);
    }

    let note = '';
    if (drawAmount < MIN_DRAW) note = `Draw amount increased to minimum of $${MIN_DRAW}.`;
    if (drawAmount > lineAmount) note = `Draw amount reduced to maximum line amount of $${lineAmount}.`;

    return {
      payment,
      appliedDraw,
      note,
    };
  }

  // --- Unified router ---------------------------------------------------

  /**
   * Unified loan/HELOC calculator.
   *
   * @param {"HELOAN"|"VARIABLE_HELOC"|"FIXED_HELOC"} type
   * @param {object} config
   *   For HELOAN:
   *     - principal  (number)
   *     - annualRate (number, %)
   *     - termYears  (number)
   *
   *   For VARIABLE_HELOC:
   *     - lineAmount (number)
   *     - drawAmount (number)
   *     - annualRate (number, %)
   *
   *   For FIXED_HELOC:
   *     - lineAmount (number)
   *     - drawAmount (number)
   *     - annualRate (number, %)
   *     - termYears  (number)
   *
   * @returns {object} Standardized result:
   *   {
   *     type,                // product type string
   *     monthlyPayment,      // numeric monthly payment
   *     details: { ... }     // product-specific details
   *   }
   */
  function calculateLoanProduct(type, config) {
    switch (type) {
      case 'HELOAN': {
        const {principal, annualRate, termYears} = config;
        const payment = calculateMortgage(principal, annualRate, termYears);

        return {
          type,
          monthlyPayment: payment,
          details: {
            principal,
            annualRate,
            termYears,
          },
        };
      }

      case 'VARIABLE_HELOC': {
        const {lineAmount, drawAmount, annualRate} = config;
        const result = calculateVariableHELOC(lineAmount, drawAmount, annualRate);

        return {
          type,
          monthlyPayment: result.payment,
          details: {
            lineAmount,
            requestedDraw: drawAmount,
            appliedDraw: result.appliedDraw,
            annualRate,
            note: result.note,
          },
        };
      }

      case 'FIXED_HELOC': {
        const {lineAmount, drawAmount, annualRate, termYears} = config;
        const result = calculateFixedHELOC(lineAmount, drawAmount, annualRate, termYears);

        return {
          type,
          monthlyPayment: result.payment,
          details: {
            lineAmount,
            requestedDraw: drawAmount,
            appliedDraw: result.appliedDraw,
            annualRate,
            termYears,
            note: result.note,
          },
        };
      }

      default:
        throw new Error(`Unsupported product type: ${type}`);
    }
  }

  function updateContactCard(data) {
    const card = widget.querySelector('.widget-card_contacts');
    if (!card) return;

    const mappingsJson = card.getAttribute('data-mappings');
    if (!mappingsJson) return;

    let mappings;
    try {
      mappings = JSON.parse(mappingsJson);
    } catch {
      console.error('Invalid mappings JSON');
      return;
    }
    const getValue = alias => {
      const map = mappings.find(m => m.alias === alias);
      if (!map) return '';
      if (map.staticValue) return map.staticValue;
      if (map.value) {
        const selector = `
                input[name="${map.value}"],
                select[name="${map.value}"],
                textarea[name="${map.value}"]
            `;
        const fields = form.querySelectorAll(selector);
        if (!fields.length) return '';

        const first = fields[0];

        if (first.type === 'radio') {
          const checked = [...fields].find(f => f.checked);
          return checked ? checked.value : '';
        }

        if (first.type === 'checkbox') {
          const checkedValues = [...fields].filter(f => f.checked).map(f => f.value);
          return checkedValues.join(', ');
        }

        return first.value || '';
      }

      return '';
    };
    // Built at runtime (not a `{{`/`}}` literal) so this survives HubSpot's HubL
    // template processing when this bundle is deployed as a Design Manager coded
    // asset — HubL treats any literal "{{"/"}}" in a coded file as its own
    // expression delimiters and strips it, which corrupted this regex live.
    const mergeTagOpen = String.fromCharCode(123, 123);
    const mergeTagClose = String.fromCharCode(125, 125);
    widget.querySelectorAll('dd[data-field]').forEach(dd => {
      const template = dd.getAttribute('data-field');

      const output = template.replace(new RegExp(`${mergeTagOpen}(.*?)${mergeTagClose}`, 'g'), (_, alias) => {
        return getValue(alias.trim()) || '';
      });

      dd.textContent =
        (template == `${mergeTagOpen}property_value${mergeTagClose}` ? '$' : '') + output || '-';
    });

    if (data.request) {
      const first = parseFloat(data.request.firstMortgageBalance);
      const creditScore = parseFloat(data.request.creditScore) || 0;

      const dd = widget.querySelector(`dd[data-field="${mergeTagOpen}loanAmount${mergeTagClose}"]`);
      const creditScoreDd = widget.querySelector(
        `dd[data-field="${mergeTagOpen}creditScore${mergeTagClose}"]`
      );

      if (!isNaN(first)) {
        dd.textContent = `$${first.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
      } else {
        dd.textContent = '-';
      }

      if (creditScore) {
        const input = widget.querySelector(`input[type="radio"][value="${creditScore}"]`);
        const label = widget.querySelector(`label[for="${input?.id}"]`);

        if (input && label) {
          creditScoreDd.textContent = label.textContent.trim();
        } else {
          creditScoreDd.textContent = '-';
        }
      }
    }
  }

  let stateCountyData = [];

  async function loadStateCountyData() {
    try {
      showLoading(form);
      const res = await fetch('//' + window.PREQUAL_EMBED.api + '/form-proxy/getStatesCounties', {
        method: 'GET',
        headers: {
          'X-Embed-PublicKey': window.PREQUAL_EMBED.publicKey,
        },
      });
      stateCountyData = await res.json();
    } catch (err) {
      console.error('Failed to load state_county.json', err);
    } finally {
      hideLoading();
    }
  }

  async function initGoogleAutocompleteUmbracoForms(el) {
    if (!el) return;
    let selectedCounty = false;

    const fieldsJson = el.getAttribute('data-mapped-fields');
    if (!fieldsJson) return;

    // Parse fields and set up county/state sync before touching Google Maps,
    // so county/state works even when Maps hasn't loaded yet.
    const form = el.closest('form');
    let mappedFields = [];
    try {
      mappedFields = JSON.parse(fieldsJson);
    } catch {
      mappedFields = [];
    }

    const getField = alias => mappedFields.find(f => f.alias === alias)?.value;

    const stateFieldName = getField('State');
    const countyFieldName = getField('County');

    const getStateSelect = () =>
      stateFieldName ? form.querySelector(`select[name="${stateFieldName}"]`) : null;

    const getCountySelect = () =>
      countyFieldName ? form.querySelector(`select[name="${countyFieldName}"]`) : null;

    let isSyncing = false;

    function updateCountyOptions(stateValue, preserveSelection = false) {
      const countySelect = getCountySelect();
      if (!countySelect) return;

      const ts = countySelect.tomselect;
      const currentValue = preserveSelection ? ts?.getValue() || countySelect.value : null;
      const filtered = stateValue ? stateCountyData.filter(x => x.state === stateValue) : [];

      if (ts) {
        // TomSelect copies options at init. Replacing the native <select> does not update the menu.
        ts.clear(true);
        ts.clearOptions();
        ts.addOptions(filtered.map(c => ({value: c.countyValue, text: c.county})));
        if (preserveSelection && currentValue && filtered.some(c => c.countyValue === currentValue)) {
          ts.setValue(currentValue, true);
        }
        ts.refreshOptions(false);
        return;
      }

      countySelect.innerHTML = '';
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Property County';
      placeholder.disabled = true;
      placeholder.selected = true;
      countySelect.appendChild(placeholder);

      filtered.forEach(c => {
        const option = document.createElement('option');
        option.value = c.countyValue;
        option.textContent = c.county;
        countySelect.appendChild(option);
      });

      if (preserveSelection && currentValue) {
        countySelect.value = currentValue;
      }
    }

    // Initial load — empty county
    updateCountyOptions('');

    // Initial load — empty county
    updateCountyOptions('');

    form.addEventListener('change', e => {
      const stateSelect = getStateSelect();
      const countySelect = getCountySelect();

      if (isSyncing) return;

      // State → County
      if (stateSelect && e.target === stateSelect) {
        const stateValue = stateSelect.value;
        updateCountyOptions(stateValue);

        if (countySelect) countySelect.value = '';
        selectedCounty = true;
      }

      // County → State
      if (countySelect && e.target === countySelect && !selectedCounty) {
        const countyValue = countySelect.value;
        const match = stateCountyData.find(x => x.countyValue === countyValue);

        if (match && stateSelect) {
          isSyncing = true;
          stateSelect.value = match.state;
          stateSelect.dispatchEvent(new Event('change', {bubbles: true}));
          isSyncing = false;
        }
      }
    });

    // Google Maps autocomplete — optional, degrades gracefully if Maps not loaded
    let autocomplete;
    try {
      const {Autocomplete} = await google.maps.importLibrary('places');
      autocomplete = new Autocomplete(el, {
        fields: ['address_components'],
        types: ['address'],
        componentRestrictions: {country: ['us']},
      });
    } catch {
      return; // Maps not available; county/state sync above still works
    }

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      if (!place || !place.address_components) return;

      const components = {};

      for (const comp of place.address_components) {
        if (comp.types.includes('street_number')) components.street = comp.long_name;
        if (comp.types.includes('route')) components.route = comp.long_name;
        if (comp.types.includes('locality')) components.city = comp.long_name;
        if (comp.types.includes('administrative_area_level_1')) {
          components.state = comp.long_name;
          components.stateValue = comp.short_name;
        }
        if (comp.types.includes('country')) components.country = comp.long_name;
        if (comp.types.includes('postal_code')) components.postcode = comp.long_name;
        if (comp.types.includes('administrative_area_level_2')) {
          components.county = comp.long_name.replace(/ county$/i, '');
        }
      }

      const street = `${components.street || ''} ${components.route || ''}`.trim();

      mappedFields.forEach(field => {
        const target = form.querySelector(`input[name="${field.value}"], select[name="${field.value}"]`);

        if (!target) return;

        const setValue = value => {
          target.value = value || '';
          target.dispatchEvent(new Event('change', {bubbles: true}));
        };

        switch (field.alias) {
          case 'Street Address':
            setValue(street);
            break;

          case 'Country':
            setValue(components.country);
            break;

          case 'State':
            if (target.tagName.toLowerCase() === 'select') {
              isSyncing = true;
              if (target.tomselect) target.tomselect.setValue(components.stateValue || '', true);
              else target.value = components.stateValue;
              updateCountyOptions(components.stateValue);
              target.dispatchEvent(new Event('change', {bubbles: true}));
              isSyncing = false;
            } else {
              setValue(components.stateValue);
            }
            break;

          case 'County':
            if (target.tagName.toLowerCase() === 'select') {
              const match = stateCountyData.find(
                x => x.county.toLowerCase() === components.county?.toLowerCase()
              );

              if (match) {
                isSyncing = true;
                if (target.tomselect) target.tomselect.setValue(match.countyValue, true);
                else target.value = match.countyValue;
                target.dispatchEvent(new Event('change', {bubbles: true}));
                isSyncing = false;
              }
            } else {
              setValue(components.county);
            }
            break;

          case 'City':
            setValue(components.city);
            break;

          case 'Zip Code':
            setValue(components.postcode);
            break;
        }
      });
    });
  }

  function initiateFormElements(selector) {
    if (selector) {
      selector.querySelectorAll('input[data-mask]:not(.js-input)').forEach(el => {
        initInputMaskByKey(el, el.getAttribute('data-mask'));
      });

      selector.querySelectorAll('input.cash-amount').forEach(el => {
        const fieldsJson = el.getAttribute('data-mapped-fields');
        if (!fieldsJson) return;

        const form = el.closest('form');
        let mappedFields = [];

        try {
          mappedFields = JSON.parse(fieldsJson);
        } catch {
          return;
        }

        let propertyValueInput = null;
        let firstMortgageInput = null;

        mappedFields.forEach(field => {
          const target = form.querySelector(`input[name="${field.value}"], select[name="${field.value}"]`);
          if (!target) return;

          switch (field.alias) {
            case 'propertyValue':
              propertyValueInput = target;
              break;
            case 'firstMortagage':
              firstMortgageInput = target;
              break;
          }
        });

        const FIELD_MAX_VALUE = 99999999;
        function enforceMaxValue(input, max) {
          if (!input) return;
          input.addEventListener('blur', function () {
            const raw = input.inputmask
              ? Number(input.inputmask.unmaskedvalue())
              : Number(String(input.value).replace(/[^\d]/g, ''));
            if (!isNaN(raw) && raw > max) {
              input.value = max;
              input.dispatchEvent(new Event('input', {bubbles: true}));
            }
          });
        }
        enforceMaxValue(propertyValueInput, FIELD_MAX_VALUE);
        enforceMaxValue(firstMortgageInput, FIELD_MAX_VALUE);

        const settings = {
          alias: 'numeric',
          min: 0,
          max: 500000,
          digits: 0,
          autoGroup: true,
          rightAlign: false,
          allowMinus: false,
          placeholder: '',
          groupSeparator: ',',
          radixPoint: '.',
        };

        initInputMask(el, settings);
        watchPropertyAgainstMortgage({
          cashInput: el,
          propertyValueInput,
          mortgageInput: firstMortgageInput,
          minimum: 25000,
        });
      });

      // Show "Property State" placeholder on the state dropdown.
      // Umbraco Forms generates an empty disabled option as first child; remove
      // disabled so the browser treats it as the default selected value.
      const stateWrapper = selector.querySelector('.propertystate');
      if (stateWrapper) {
        const stateEl = stateWrapper.querySelector('select');
        if (stateEl) {
          let emptyOpt = stateEl.querySelector('option[value=""]');
          if (!emptyOpt) {
            emptyOpt = document.createElement('option');
            emptyOpt.value = '';
            stateEl.insertBefore(emptyOpt, stateEl.firstChild);
          }
          emptyOpt.removeAttribute('disabled');
          emptyOpt.textContent = 'Property State';
          emptyOpt.selected = true;
        }
      }

      selector.querySelectorAll('select.js-select').forEach(el => {
        if (el.multiple) initTomMultiCheckboxSelect(el);
        else initTomSelect(el, {searchEnabled: true});
      });

      selector.querySelectorAll('.js-intlTel').forEach(input => {
        initIntlTelInput(input);
      });

      selector.querySelectorAll('.google-autocomplete').forEach(async el => {
        await loadStateCountyData();
        await initGoogleAutocompleteUmbracoForms(el);
      });

      selector.querySelectorAll('.js-range-slider').forEach(el => {
        initRangeSlider(el);

        const sliderJs = widget.querySelector('.js-range-slider');

        let debounceTimer;
        if (sliderJs) {
          sliderJs.noUiSlider.on('set', function (values, handle) {
            if (suppressSetEvent) return;
            clearTimeout(debounceTimer);

            debounceTimer = setTimeout(async () => {
              const data = await fetchData();
              let cashAmount = values[0];
              if (cashAmount) {
                const mappingsJson = form
                  .querySelector('.widget-card_contacts')
                  ?.getAttribute('data-mappings');
                let mappings;
                try {
                  mappings = JSON.parse(mappingsJson);
                  const cashAmountField = mappings.find(x => x.alias === 'cashAmount');
                  const inputName = cashAmountField?.value;
                  const el = inputName ? document.querySelector(`[name="${inputName}"]`) : null;
                  el.value = cashAmount;
                } catch {
                  console.error('Invalid mappings JSON');
                }
              }
              updateLoanCards(JSON.parse(data.result));
              var result = await updateLead();
              if (result?.invalidState || data.invalidState) {
                ShowMessageModal(result?.message);
              }
            }, 300);
          });
        }
      });

      selector.querySelectorAll('.span-tooltip').forEach(el => {
        bootstrap.Tooltip.getOrCreateInstance(el, {
          placement: 'top',
          trigger: 'hover',
        });
      });
    }
  }

  function initiateLastPageListeners() {
    if (isLatham) {
      form.querySelectorAll('[data-prequal-product-selected]').forEach(link => {
        try {
          const lathamUrl = new URL('https://latham.applyeq.com');
          const hsObjectId = getQueryParam('hs_object_id');
          if (hsObjectId) lathamUrl.searchParams.set('hs_object_id', hsObjectId);
          link.href = lathamUrl.toString();
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
        } catch {}
      });
    }

    const pandaKey = getQueryParam('cain_key') || getQueryParam('key');
    if (pandaKey) {
      form.querySelectorAll('[data-prequal-product-selected]').forEach(link => {
        try {
          const applyUrl = new URL(link.href);
          const passthrough = applyUrl.searchParams.get('passthrough');
          if (passthrough) {
            try {
              const passthroughObj = JSON.parse(passthrough);
              passthroughObj.cid = pandaKey;
              applyUrl.searchParams.set('passthrough', JSON.stringify(passthroughObj));
            } catch {}
          } else {
            applyUrl.searchParams.set('cain_key', pandaKey);
          }
          link.href = applyUrl.toString();
        } catch {}
      });
    }

    // Fix mobile collapse toggle for contact details — use programmatic control to
    // prevent Bootstrap's auto-init from losing track of state on some mobile browsers.
    const contactsCard = widget.querySelector('.widget-card_contacts');
    if (contactsCard) {
      const mobileToggle = contactsCard.querySelector('[data-bs-target="#collapseOne"]');
      const collapseEl = widget.querySelector('#collapseOne');
      if (mobileToggle && collapseEl) {
        mobileToggle.removeAttribute('data-bs-toggle');
        mobileToggle.removeAttribute('data-bs-target');
        const collapseInstance = bootstrap.Collapse.getOrCreateInstance(collapseEl, {toggle: false});
        mobileToggle.addEventListener('click', () => collapseInstance.toggle());
        collapseEl.addEventListener('shown.bs.collapse', () => {
          mobileToggle.classList.remove('collapsed');
          mobileToggle.setAttribute('aria-expanded', 'true');
        });
        collapseEl.addEventListener('hidden.bs.collapse', () => {
          mobileToggle.classList.add('collapsed');
          mobileToggle.setAttribute('aria-expanded', 'false');
        });
      }
    }

    // const years = form.querySelectorAll(
    //   '[data-scenario="HELOAN"] [data-field="term-list"] input[type="radio"]'
    // );
    // years.forEach(year => {
    //   year.addEventListener('change', e => {
    //     const widgetCardInfo = year.closest('.widget-card_info');
    //     const paymentLabels = widgetCardInfo.querySelectorAll(
    //       'data[data-value], [data-field="subtext"], [data-field="origination-costs"]'
    //     );
    //     paymentLabels.forEach(lbl => lbl.classList.add('d-none'));
    //     const selected = widgetCardInfo.querySelectorAll(
    //       `data[data-value="${e.target.value}"], [data-value="${e.target.value}"][data-field="subtext"], [data-value="${e.target.value}"][data-field="origination-costs"]`
    //     );
    //     if (selected) {
    //       selected.forEach(lbl => lbl.classList.remove('d-none'));
    //     }
    //   });
    // });

    const fixedAndVariableHelocInputs = form.querySelectorAll(
      '[data-scenario="HELOAN"] .card-list-group input[type="radio"], [data-scenario="FIXED_HELOC"] .card-list-group input[type="radio"], [data-scenario="VARIABLE_HELOC"] .card-list-group input[type="radio"]'
    );
    fixedAndVariableHelocInputs.forEach(input => {
      input.addEventListener('change', e => {
        const widgetCardInfo = input.closest('.widget-card_info');
        const termValue =
          widgetCardInfo.querySelector('[data-field="term-list"] input:checked')?.value || '30';
        const termTeaserValue =
          widgetCardInfo.querySelector('[data-field="teaser-term-list"] input:checked')?.value || '1';
        const paymentLabels = widgetCardInfo.querySelectorAll(
          'data[data-field], data[data-value], [data-field="subtext"], [data-field="origination-costs"]'
        );
        paymentLabels.forEach(lbl => lbl.classList.add('d-none'));

        if (widgetCardInfo.classList.contains('has-teaser')) {
          const selected = widgetCardInfo.querySelectorAll(
            `data[data-term="${termValue}"][data-teaser="${termTeaserValue}"], [data-value="${termValue}"][data-teaser="${termTeaserValue}"][data-field="subtext"], [data-value="${termValue}"][data-field="origination-costs"]`
          );
          if (selected) {
            selected.forEach(lbl => lbl.classList.remove('d-none'));
          }
          if (widgetCardInfo.classList.contains('latham-teaser')) {
            const notePaymentEl = widgetCardInfo.querySelector(
              `[data-latham-note-payment] [data-term="${termValue}"][data-field="note-payment"]`
            );
            if (notePaymentEl) notePaymentEl.classList.remove('d-none');
            widgetCardInfo.querySelectorAll('[data-latham-disclosure] [data-term]').forEach(el => {
              el.classList.toggle('d-none', el.dataset.term !== termValue);
            });
          }
        } else {
          const selected = widgetCardInfo.querySelectorAll(
            `data[data-term="${termValue}"], [data-value="${termValue}"][data-field="subtext"], [data-value="${termValue}"][data-field="origination-costs"]`
          );
          if (selected) {
            selected.forEach(lbl => lbl.classList.remove('d-none'));
          }
        }
      });
    });

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.accordion-btn');
      if (!btn) return;

      const panel = document.querySelector(btn.getAttribute('data-target'));
      if (!panel) return;

      const isOpen = panel.classList.contains('show');

      btn.classList.toggle('collapsed', isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));

      if (isOpen) {
        panel.style.height = panel.scrollHeight + 'px';
        requestAnimationFrame(() => {
          panel.style.height = '0px';
          panel.classList.remove('show');
        });
      } else {
        panel.classList.add('show');
        panel.style.height = 'auto';
        const height = panel.scrollHeight;
        panel.style.height = '0px';
        requestAnimationFrame(() => {
          panel.style.height = height + 'px';
        });

        panel.addEventListener('transitionend', function handler() {
          panel.style.height = 'auto';
          panel.removeEventListener('transitionend', handler);
        });
      }
    });

    form.querySelectorAll('[data-prequal-product-selected]').forEach(link => {
      link.addEventListener('click', async function (e) {
        const selectedProduct = link.dataset.prequalProductSelected;
        if (selectedProduct) {
          e.preventDefault();
          showLoading();
          var result = await updateLead(selectedProduct);
          hideLoading();
          if (result?.invalidState) {
            ShowMessageModal(result?.message);
            return;
          }
          window.open(link.href, '_blank', 'noopener,noreferrer');
        }
      });
    });
  }

  function ensureInvalidStateModal() {
    let modalEl = document.getElementById('invalidStateModal');

    if (!modalEl) {
      modalEl = document.createElement('div');
      modalEl.id = 'invalidStateModal';
      modalEl.className = 'modal fade';
      modalEl.tabIndex = -1;

      modalEl.innerHTML = `
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Unsupported State</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body"></div>
          </div>
        </div>
      `;

      document.body.appendChild(modalEl);
    }

    return modalEl;
  }

  function ShowMessageModal(message) {
    if (!message) return;
    const modalEl = ensureInvalidStateModal();

    modalEl.querySelector('.modal-body').textContent = message;

    const modal = new bootstrap.Modal(modalEl);
    modal.show();
  }

  function AddSkeleton() {
    const monthlyPaymentElements = document.querySelectorAll('[data-field="monthly-payment"]');
    const elementsToSkeleton = widget.querySelectorAll(
      '[data-field="subtext"], .contact-info dd, .card-text, .card-title, [data-term-container], .btn-primary, .min-draw-amount, .item-label, .into-text'
    );
    monthlyPaymentElements.forEach(el => {
      el.closest('.item-value').classList.add('skeleton');
    });
    elementsToSkeleton.forEach(el => {
      el.classList.add('skeleton');
    });
  }

  function RemoveSkeleton() {
    widget.querySelectorAll('.skeleton')?.forEach(el => {
      el.classList.remove('skeleton');
    });
  }

  function buildMobileStepDropdown() {
    const tabButtons = Array.from(widget.querySelectorAll('[data-bs-toggle="tab"][data-step]'));
    const navWrapper = widget.querySelector('.nav-tabs-wrapper');
    if (!tabButtons.length || !navWrapper) return;

    const dropdown = document.createElement('div');
    dropdown.className = 'step-mobile-dropdown d-lg-none';

    const activeTab = tabButtons.find(t => t.classList.contains('active')) || tabButtons[0];
    const activeCaption = activeTab?.querySelector('span:last-child')?.textContent?.trim() || '';
    const activeStepNum = activeTab?.dataset.step || '1';

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'step-mobile-toggle';
    toggle.innerHTML = `<span class="step-mobile-indicator">${activeStepNum}</span><span class="step-mobile-label">${activeCaption}</span><span class="step-mobile-chevron ms-auto"></span>`;

    const menu = document.createElement('div');
    menu.className = 'step-mobile-menu';

    tabButtons.forEach(tab => {
      const stepNum = tab.dataset.step;
      const caption = tab.querySelector('span:last-child')?.textContent?.trim() || '';
      const isCompleted = tab.classList.contains('completed');

      const item = document.createElement('button');
      item.type = 'button';
      item.className =
        'step-mobile-item' +
        (tab.classList.contains('active') ? ' active' : '') +
        (isCompleted ? ' completed' : '');
      item.disabled = tab.disabled;
      item.dataset.step = stepNum;
      item.innerHTML = `<span class="step-item-badge">${stepNum}</span><span class="step-item-check"><svg class="svg-icon svg-icon-fill icon-check-circle-fill text-primary"><use xlink:href="../images/spritemap/spritemap.svg#icon-check-circle-fill"></use></svg></span><span>${caption}</span>`;

      item.addEventListener('click', () => {
        const targetTab = widget.querySelector(`[data-bs-toggle="tab"][data-step="${item.dataset.step}"]`);
        if (!targetTab || targetTab.disabled) return;
        bootstrap.Tab.getOrCreateInstance(targetTab).show();
        menu.classList.remove('show');
        toggle.classList.remove('open');
      });
      menu.appendChild(item);
    });

    // Sync live disabled states from tabs before opening the menu.
    const syncItemStates = () => {
      tabButtons.forEach(tab => {
        const item = menu.querySelector(`.step-mobile-item[data-step="${tab.dataset.step}"]`);
        if (!item) return;
        item.disabled = tab.disabled;
        item.classList.toggle('completed', tab.classList.contains('completed'));
      });
    };

    toggle.addEventListener('click', e => {
      e.stopPropagation();
      syncItemStates();
      menu.classList.toggle('show');
      toggle.classList.toggle('open');
    });

    document.addEventListener('click', e => {
      if (!dropdown.contains(e.target)) {
        menu.classList.remove('show');
        toggle.classList.remove('open');
      }
    });

    dropdown.appendChild(toggle);
    dropdown.appendChild(menu);
    navWrapper.parentElement.insertBefore(dropdown, navWrapper);

    widget.addEventListener('shown.bs.tab', e => {
      const step = e.target.dataset.step;
      const caption = e.target.querySelector('span:last-child')?.textContent?.trim() || '';
      toggle.querySelector('.step-mobile-label').textContent = caption;
      menu.querySelectorAll('.step-mobile-item').forEach(item => {
        item.classList.toggle('active', item.dataset.step === step);
      });
    });
  }

  initiateFormElements(form);

  // Fix ZIP input maxlength (Umbraco Forms default is 255)
  form.querySelectorAll('input[placeholder*="ZIP"]').forEach(input => {
    input.setAttribute('maxlength', '10');
  });

  // A11y: remove invalid `for` attributes from hidden labels
  form.querySelectorAll('label.umbraco-forms-hidden[for]').forEach(label => {
    const targetId = label.getAttribute('for');
    if (targetId && !form.querySelector(`#${CSS.escape(targetId)}`)) {
      label.removeAttribute('for');
    }
  });

  // Fix disclaimer links (Umbraco Forms rich text renders them with href="#")
  form.querySelectorAll('a[data-router-slot="disabled"][href="#"]').forEach(link => {
    const text = link.textContent.trim().toLowerCase();
    if (text.includes('privacy policy')) {
      link.href = 'https://mortgage.springeq.com/privacy-policy';
      link.target = '_blank';
    } else if (text.includes('terms of use')) {
      link.href = 'https://mortgage.springeq.com/terms-of-use';
      link.target = '_blank';
    } else if (text.includes('california') || text.includes('here')) {
      link.href = 'https://mortgage.springeq.com/california-privacy-policy';
      link.target = '_blank';
    }
  });

  // Push initial step 1 GTM event
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({event: 'page_view', page_title: 'Lead Info', step_name: 'Lead Info'});

  initiateLastPageListeners();
  if (isStepsMode) buildMobileStepDropdown();

  // Restore the active tab from the URL hash immediately (before prefillForm fetch).
  if (isStepsMode) {
    const hashMatch = window.location.hash.match(/^#step-(\d+)$/);
    if (hashMatch) {
      const targetStep = Number(hashMatch[1]);
      if (targetStep > 1) {
        const targetTab = widget.querySelector(`[data-bs-toggle="tab"][data-step="${targetStep}"]`);
        if (targetTab) {
          activeStep = targetStep;
          bootstrap.Tab.getOrCreateInstance(targetTab).show();
        }
      }
    }
  }
  prefillForm().then(() => {
    prefillComplete = true;
    updateTabCompletedStates();
    if (isStepsMode && Number(activeStep) === maxStep && !resultsLoaded && getQueryParam('hs_object_id')) {
      fetchResults();
    }
  });
};
